import React, { useContext, useEffect, useState, useCallback, useMemo, useRef } from 'react';
import styles from './ticket.module.css'
import { withRouter, Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useLocation, useHistory } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import {
    Box,
    Button,
    Grid,
    Tooltip,
    Typography,
    Chip,
    Avatar,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Autocomplete,
    ListSubheader,
    Divider,
    useMediaQuery,
    LinearProgress,
} from '@mui/material';
import { FilterAltSharp, FilterList as FilterListIcon, MoreVert, SwapHoriz, FileDownload, Settings as SettingsFilterIcon, ChevronLeft, ChevronRight, MergeType, DeleteOutline, LabelOutlined, MiscellaneousServices, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { formatAttendanceDuration } from '../../utils/formatAttendanceDuration';
import * as XLSX from 'xlsx';
import { fetchTickets, createTicket, setViewedTickets, selectViewedTickets, mapPriority, mapStatus, editTicket } from '../../redux/ticket/ticket.actions';
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import http from '../../services/http';
import AdvancedSearchModal from '../../components/AdvancedSearchModal';
import { addFilter, fetchFilters, updateFilter, setSelectedFilter } from '../../redux/filter/filter.actions';
import SearchBar from '../../components/SearchBar';
import { getUsers } from '../../redux/user/user.actions';
import { toast } from 'react-toastify';
import TicketKanbanView from '../../components/TicketKanbanView';
import TicketListVirtuoso from '../../components/TicketListVirtuoso';
import { estiloDeCelula, marcaDeTipo } from '../../utils/listagemDeChamados';
import ServicePicker from '../../components/ServicePicker';
import StatusJustificationPicker from '../../components/StatusJustificationPicker';
import {
    applyAdvancedSearchFilters,
    formatTicketClientDisplay,
    textoDeBuscaDoCliente,
    getTicketAssigneeServiceGroupId,
} from '../../utils/ticketAdvancedSearchFilters';
import { getTicketAssigneeDisplayName, normalizeTicketAssigneeForList, ehGrupoSemResponsavel } from '../../utils/ticketAssignee';
import { useRepresentantes } from '../../utils/nomeDoRepresentante';
import { avaliarValorDinamico } from '../../utils/filtroDinamico';
import { idsFinalizados } from '../../utils/statusDoChamado';
import { finalizadosReferenciados, temCondicaoDeStatus } from '../../utils/finalizadosDoFiltro';
import { OPCOES_DE_ORDENACAO, ORDENACAO_PADRAO, ordenarChamados } from '../../utils/ordenarChamados';
import { totalDaColunaDoKanban } from '../../utils/totalDaColunaDoKanban';
import { chamadoNoServico, paiPorServico } from '../../utils/arvoreDeServicos';
import { condicoesDaBuscaAvancada, totalVemDoServidor } from '../../utils/condicoesDaBuscaAvancada';
import { ESPACO_ENTRE_COLUNAS, gradeDeColunas, larguraMinimaDaGrade } from '../../utils/colunasDoKanban';
import { responsaveisVisiveisNoKanban, responsavelVisivelNoKanban } from '../../utils/responsaveisVisiveisNoKanban';
import ListaDeFiltros from '../../components/ListaDeFiltros';
import { avaliarOperadorDeLista } from '../../utils/condicaoDeLista';
import { proximaOrdenacao } from '../../utils/ticketListSorting';
import { parseKanbanColumnsFromFilter, isArchiveColumn } from '../../utils/kanbanFilterItems';
import { isDatePeriodOperator, ticketMatchesDatePeriod } from '../../utils/datePeriods';
// A lista de "abertos hoje" vem INTEIRA do servidor; o lacar de paginas e o
// teto moram no util, onde da para testa-los sem montar esta tela de 3.397
// linhas.
import { buscarCriadosHoje } from '../../utils/criadosHoje';
import { numerosDoChamado } from '../../utils/numerosDoChamado';
import { casaColuna, foraDasColunas } from '../../utils/cabeNaColuna';
import {
    getTicketExportColumns,
    ticketToExportRow,
} from '../../utils/ticketExportColumns';
import {
    lerRefinamentosDaListagem,
    gravarRefinamentosDaListagem,
    limparRefinamentosDaListagem,
} from '../../utils/refinamentosDaListagem';
import { valorDoCampoCustomizado } from '../../utils/valorDoCampoCustomizado';
import LixeiraDeChamados from '../../components/LixeiraDeChamados';
import { estadoDaListagem, CARREGANDO, TEXTO_CARREGANDO } from '../../utils/estadoDaListagem';

const getTicketStatusName = (ticket) =>
    ticket.ticket_status?.name ?? ticket.ticketStatus?.name ?? null;

const formatTicketDateTime = (value) => {
    if (value == null || value === '') return '';
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('pt-BR');
};

/** Data/hora curta para células da listagem compacta */
const formatTicketDateTimeCompact = (value) => {
    if (value == null || value === '') return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    try {
        return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
    } catch {
        return d.toLocaleString('pt-BR');
    }
};

const TICKET_LIST_STATUS_CHIP_COLORS = {
    Aberto: { bg: 'rgba(76, 175, 80, 0.15)', dot: '#4CAF50' },
    Pendente: { bg: 'rgba(255, 152, 0, 0.15)', dot: '#FF9800' },
    Fechado: { bg: 'rgba(244, 67, 54, 0.15)', dot: '#F44336' },
    Resolvido: { bg: 'rgba(255, 193, 7, 0.15)', dot: '#FFC107' },
    Cancelado: { bg: 'rgba(244, 67, 54, 0.15)', dot: '#F44336' },
};

const TICKET_LIST_PRIORITY_TEXT_COLORS = { Baixa: 'green', Média: 'orange', Alta: 'red' };

const startOfLocalDayTs = (ms) => {
    const d = new Date(ms);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
};

const endOfLocalDayTs = (ms) => {
    const d = new Date(ms);
    d.setHours(23, 59, 59, 999);
    return d.getTime();
};

/** Condições de filtro (lista de tickets) para campos de data/hora. */
const applyTicketDateCondition = (ticketValueRaw, operator, filterValue) => {
    const hasTicket = ticketValueRaw != null && ticketValueRaw !== '';
    const ticketMs = hasTicket ? new Date(ticketValueRaw).getTime() : NaN;
    const validTicket = !Number.isNaN(ticketMs);

    if (operator === 'is_null') return !validTicket;
    if (operator === 'is_not_null') return validTicket;
    if (!validTicket) return false;

    // Operadores de período relativo (hoje, esta semana, este mês, últimos N
    // dias, intervalo) — itens 52 e 9.
    if (isDatePeriodOperator(operator)) {
        return ticketMatchesDatePeriod(ticketValueRaw, operator, filterValue);
    }

    const filterMs = filterValue != null && filterValue !== '' ? new Date(filterValue).getTime() : NaN;
    if (Number.isNaN(filterMs)) return false;

    const fStart = startOfLocalDayTs(filterMs);
    const fEnd = endOfLocalDayTs(filterMs);

    switch (operator) {
        case 'equals':
            return ticketMs >= fStart && ticketMs <= fEnd;
        case 'not_equals':
            return ticketMs < fStart || ticketMs > fEnd;
        case 'greater_than':
            return ticketMs > fEnd;
        case 'less_than':
            return ticketMs < fStart;
        case 'greater_than_or_equal':
            return ticketMs >= fStart;
        case 'less_than_or_equal':
            return ticketMs <= fEnd;
        case 'contains':
            return String(ticketValueRaw).toLowerCase().includes(String(filterValue).toLowerCase());
        case 'not_contains':
            return !String(ticketValueRaw).toLowerCase().includes(String(filterValue).toLowerCase());
        case 'starts_with':
            return String(ticketValueRaw).toLowerCase().startsWith(String(filterValue).toLowerCase());
        case 'ends_with':
            return String(ticketValueRaw).toLowerCase().endsWith(String(filterValue).toLowerCase());
        default:
            return true;
    }
};

const rawLegacyStatusColumn = (ticket) => {
    if (ticket.status == null || ticket.status === '') return null;
    const n = Number(ticket.status);
    return Number.isNaN(n) ? null : n;
};

const getTicketStatusId = (ticket) => {
    const v = ticket.status_id ?? ticket.ticket_status?.id ?? ticket.ticketStatus?.id;
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
};

const isEmAtendimento = (ticket, emAtendimentoStatusId) => {
    const name = getTicketStatusName(ticket);
    if (name === 'Em atendimento') return true;
    if (emAtendimentoStatusId != null) {
        const sid = getTicketStatusId(ticket);
        if (sid != null && sid === Number(emAtendimentoStatusId)) return true;
    }
    return false;
};

const isFechadoShortcut = (ticket) => {
    if (getTicketStatusName(ticket) === 'Fechado') return true;
    return rawLegacyStatusColumn(ticket) === 0;
};

const isCanceladoShortcut = (ticket) => {
    if (getTicketStatusName(ticket) === 'Cancelado') return true;
    return rawLegacyStatusColumn(ticket) === 4;
};

const isResolvidoShortcut = (ticket, emAtendimentoStatusId) => {
    if (isEmAtendimento(ticket, emAtendimentoStatusId)) return false;
    if (getTicketStatusName(ticket) === 'Resolvido') return true;
    return rawLegacyStatusColumn(ticket) === 3;
};

const isAbertoShortcut = (ticket, abertoStatusId, emAtendimentoStatusId) => {
    if (isEmAtendimento(ticket, emAtendimentoStatusId)) return false;
    const n = getTicketStatusName(ticket);
    if (n === 'Pendente' || n === 'Fechado' || n === 'Cancelado' || n === 'Resolvido') return false;
    const sid = getTicketStatusId(ticket);
    if (abertoStatusId != null && sid != null && sid === Number(abertoStatusId)) return true;
    if (n === 'Aberto') return true;
    if (sid != null) return false;
    return rawLegacyStatusColumn(ticket) === 1;
};

const isParadoShortcut = (ticket, pendenteStatusId, emAtendimentoStatusId, abertoStatusId) => {
    if (isEmAtendimento(ticket, emAtendimentoStatusId)) return false;
    const n = getTicketStatusName(ticket);
    const sid = getTicketStatusId(ticket);
    if (pendenteStatusId != null && sid != null && sid === Number(pendenteStatusId)) return true;
    if (n === 'Pendente') return true;
    if (sid != null) return false;
    return rawLegacyStatusColumn(ticket) === 2;
};

const applyIndicatorShortcutFilter = (tickets, shortcut, currentUser, options = {}) => {
    if (!shortcut?.scope || !shortcut?.sub) return tickets;
    if ((shortcut.scope === 'my' || shortcut.scope === 'team') && !currentUser?.id) {
        return tickets;
    }

    const emAtendimentoStatusId = options.emAtendimentoStatusId ?? null;
    const abertoStatusId = options.abertoStatusId ?? null;
    const pendenteStatusId = options.pendenteStatusId ?? null;

    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    const endOfToday = new Date();
    endOfToday.setHours(23, 59, 59, 999);

    return tickets.filter((ticket) => {
        const assignedId = ticket.assigned_to?.id ?? ticket.assigned_to;
        const assigneeSg =
            ticket.assigned_to?.service_group_id ??
            ticket.assigned_to?.service_group?.id ??
            getTicketAssigneeServiceGroupId(ticket) ??
            null;

        if (shortcut.scope === 'my') {
            if (assignedId == null || assignedId === '') return false;
            if (Number(assignedId) !== Number(currentUser.id)) return false;
        } else if (shortcut.scope === 'team') {
            if (currentUser.service_group_id == null) return false;
            if (assigneeSg == null || Number(assigneeSg) !== Number(currentUser.service_group_id)) return false;
        }

        if (shortcut.sub === 'openedToday') {
            if (!ticket.created_at) return false;
            const d = new Date(ticket.created_at);
            return d >= startOfToday && d <= endOfToday;
        }

        switch (shortcut.sub) {
            case 'pending':
                if (isFechadoShortcut(ticket)) return false;
                if (isCanceladoShortcut(ticket)) return false;
                if (isResolvidoShortcut(ticket, emAtendimentoStatusId)) return false;
                return true;
            case 'new':
                return isAbertoShortcut(ticket, abertoStatusId, emAtendimentoStatusId);
            case 'inProgress':
                return isEmAtendimento(ticket, emAtendimentoStatusId);
            case 'stalled':
                return isParadoShortcut(ticket, pendenteStatusId, emAtendimentoStatusId, abertoStatusId);
            default:
                return true;
        }
    });
};

const IND_SHORTCUT_SCOPES = ['my', 'team', 'all'];
const IND_SHORTCUT_SUBS = ['pending', 'new', 'inProgress', 'stalled', 'openedToday'];

// Produto e Representante do ticket vêm da empresa (company) do cliente vinculado.
const getTicketCompany = (t) => {
    const tc = Array.isArray(t?.ticket_clients) ? t.ticket_clients : [];
    for (const c of tc) { if (c?.company) return c.company; }
    return t?.company || null;
};
const getTicketProduct = (t) => getTicketCompany(t)?.product_description || '';
const getTicketRepresentative = (t) => getTicketCompany(t)?.service_group_description || '';
// Serviço do ticket como caminho "grupo → subserviço" (igual ao seletor de
// serviço). Se for de topo (sem pai), mostra só o nome. Item 6.
const getTicketServiceLabel = (t) => {
    const s = t?.service;
    if (!s) return '';
    return s.parent?.name ? `${s.parent.name} → ${s.name}` : (s.name || '');
};

const TicketPage = props => {
    const location = useLocation();
    const history = useHistory();
    // Mapa código -> nome do representante, buscado uma vez por sessão. Vazio
    // enquanto não chega, e aí o nome do responsável sai como sempre saiu.
    const representantes = useRepresentantes();
    const [rows, setRows] = useState([]);

    // ------------------------------------------- ordenacao por clique
    //
    // A listagem normalmente e montada AQUI: os ativos vem inteiros do
    // `GET /ticket?scope=active` e ficam em memoria, os finalizados chegam
    // de 100 em 100 conforme a rolagem, e os dois sao mesclados e filtrados
    // no navegador. Isso funcionava com 6,4 mil chamados.
    //
    // Com 262 mil nao funciona mais para ORDENAR: os finalizados sao a
    // quase totalidade e so uma fracao esta carregada, entao ordenar o que
    // esta em memoria daria uma ordem que parece certa e nao e.
    //
    // Por isso, enquanto ha ordenacao escolhida, a lista passa a vir INTEIRA
    // do servidor, ja ordenada e paginada por ele. Sem ordenacao escolhida
    // (`sort === null`), nada muda: e o caminho de sempre.
    const [sort, setSort] = useState(null);
    const [sortedRows, setSortedRows] = useState(null);
    const [sortedPage, setSortedPage] = useState(1);
    const [sortedHasMore, setSortedHasMore] = useState(false);
    const sortedLoadingRef = useRef(false);
    /*
     * As buscas no SERVIDOR (ordenação e busca por texto) em estado, não só
     * em `ref`.
     *
     * Os `ref`s acima existem para impedir duas requisições ao mesmo tempo, e
     * `ref` não redesenha nada -- por isso a tela ficava muda justamente nas
     * duas esperas mais longas que ela tem. O contador, e não um booleano:
     * ordenação e busca podem estar em andamento ao mesmo tempo, e a primeira
     * a terminar desligaria o aviso da outra.
     */
    const [buscasNoServidor, setBuscasNoServidor] = useState(0);
    const comecouBuscaNoServidor = useCallback(() => setBuscasNoServidor((n) => n + 1), []);
    const terminouBuscaNoServidor = useCallback(() => setBuscasNoServidor((n) => Math.max(0, n - 1)), []);
    // ------------------------------------------- "abertos hoje" vem do servidor
    //
    // Os outros quatro cards dos indicadores recortam DENTRO da lista de
    // ativos, que o front tem inteira em memória -- então refinar aqui dá o
    // número certo.
    //
    // "Abertos hoje" não: ele conta o que foi CRIADO hoje, resolvido ou não
    // (decisão do dono do produto em 02/10). Os finalizados chegam de 100 em
    // 100 conforme a rolagem, então refinar no navegador media apenas o que já
    // havia descido -- e era essa a origem do "card diz 30, lista mostra 18".
    //
    // `null` = este card não está ativo, e nada nesta parte do código muda.
    const [linhasDeHoje, setLinhasDeHoje] = useState(null);
    const [totalDeHoje, setTotalDeHoje] = useState(null);
    // Faixa visível na listagem (item 9): header mostra "Exibindo X a Y de total".
    const [visibleRange, setVisibleRange] = useState({ startIndex: 0, endIndex: 0 });
    // Total REAL da categoria/filtro (contado no servidor, inclui finalizados) — item 9.
    const [listTotal, setListTotal] = useState(null);
    const { theme } = useContext(ThemeContext);
    const persistedSessionRef = useRef(lerRefinamentosDaListagem());
    const [searchValue, setSearchValue] = useState(persistedSessionRef.current.searchValue || '');
    const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);
    const [advancedSearchFilters, setAdvancedSearchFilters] = useState(persistedSessionRef.current.advancedSearchFilters || null);
    const [actionsAnchorEl, setActionsAnchorEl] = useState(null);
    const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
    // A lixeira de chamados (pontos 8 e 9 da Gisele, 27/10/2026).
    const [lixeiraAberta, setLixeiraAberta] = useState(false);
    const [actionsTicket, setActionsTicket] = useState(null);
    const [transferModalOpen, setTransferModalOpen] = useState(false);
    const [transferUser, setTransferUser] = useState(null);
    const [mergeModalOpen, setMergeModalOpen] = useState(false);
    const [mergeTargetTicket, setMergeTargetTicket] = useState(null);
    const [mergePrimaryChoice, setMergePrimaryChoice] = useState('current');
    const [rememberMergeChoice, setRememberMergeChoice] = useState(false);
    const [mergeSaving, setMergeSaving] = useState(false);
    const [selectedTicketIds, setSelectedTicketIds] = useState([]);
    const [bulkTicketIds, setBulkTicketIds] = useState([]);
    const [bulkDeleteOpen, setBulkDeleteOpen] = useState(false);
    const [bulkDeleting, setBulkDeleting] = useState(false);
    // Ações rápidas em massa (menu Opções): alterar status / serviço dos selecionados.
    const [services, setServices] = useState([]);
    const [bulkStatusOpen, setBulkStatusOpen] = useState(false);
    const [bulkStatusValue, setBulkStatusValue] = useState({ statusId: null, substatusId: null });
    const [bulkServiceOpen, setBulkServiceOpen] = useState(false);
    const [bulkServiceId, setBulkServiceId] = useState(null);
    const [bulkApplying, setBulkApplying] = useState(false);
    const [ticketStatuses, setTicketStatuses] = useState([]);
    const [indicatorShortcut, setIndicatorShortcut] = useState(persistedSessionRef.current.indicatorShortcut || null);
    // Filtro vindo do Painel de tickets (sino): { label, ids } — restringe a lista.
    const [panelFilter, setPanelFilter] = useState(null);
    const tableWrapperRef = useRef(null);
    const scrollRestoredRef = useRef(false);
    // Resultados de busca server-side (inclui histórico fechado). null = sem busca ativa.
    const [serverSearchResults, setServerSearchResults] = useState(null);
    // Paginação da busca (scroll infinito): página atual e última página.
    const [searchMeta, setSearchMeta] = useState({ page: 0, lastPage: 0 });
    const searchLoadingRef = useRef(false);
    // Contagem real por status (kanban) e cards carregados sob demanda por coluna.
    const [kanbanCounts, setKanbanCounts] = useState(null);
    const [assigneeCounts, setAssigneeCounts] = useState(null);
    // Histórico carregado sob demanda, por responsável (grupo do kanban).
    const [groupExtra, setGroupExtra] = useState({});
    // Responsáveis (grupos) atualmente expandidos no kanban.
    const [expandedAssigneeKeys, setExpandedAssigneeKeys] = useState([]);
    const loadingGroupsRef = useRef({});
    const isTicketMobileLayout = useMediaQuery('(max-width: 899px)');
    const isDefaultListMdDown = useMediaQuery(theme.breakpoints.down('md'));
    const isDefaultListSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    const [isFilterPanelCollapsed, setIsFilterPanelCollapsed] = useState(() => {
        try {
            const saved = localStorage.getItem('ticket-page-filter-panel-collapsed');
            return saved === 'true';
        } catch {
            return false;
        }
    });
    const shouldCollapseFilterPanel = !isTicketMobileLayout && isFilterPanelCollapsed;
    const canMergeTickets = Boolean(
        props.currentUser?.is_super_admin ||
        (Array.isArray(props.permissions) && props.permissions.includes('#mesclar-tickets'))
    );
    const canDeleteTickets = Boolean(
        props.currentUser?.is_super_admin ||
        (Array.isArray(props.permissions) && props.permissions.includes('#excluir-tickets'))
    );

    // A ordenação dos cartões DENTRO de cada coluna do quadro (K9 da Gisele).
    //
    // Estado próprio, e não o `sort` da listagem: aquele liga um modo de
    // paginação server-side inteiro (`sortedRows`), que o quadro não usa --
    // ele pagina por (responsável × coluna). Compartilhar o estado faria uma
    // visão ligar o caminho da outra.
    const [kanbanSort, setKanbanSort] = useState(ORDENACAO_PADRAO);

    // Os ids dos status finais, uma vez. Serve a DOIS consumidores que antes
    // tinham cada um a sua cópia do array de nomes: a avaliação do valor
    // "Não concluído" no navegador e a decisão de quais finalizados buscar
    // sob demanda (`filterFinalizedStatusIds`, mais abaixo).
    const idsDeStatusFinalizados = useMemo(
        () => idsFinalizados(ticketStatuses),
        [ticketStatuses],
    );

    const emAtendimentoStatusId = useMemo(() => {
        const list = ticketStatuses ?? [];
        const found = list.find((st) => st.name === 'Em atendimento');
        if (found?.id == null) return null;
        const n = Number(found.id);
        return Number.isNaN(n) ? null : n;
    }, [ticketStatuses]);

    const abertoStatusId = useMemo(() => {
        const list = ticketStatuses ?? [];
        const found = list.find((st) => st.name === 'Aberto');
        if (found?.id == null) return null;
        const n = Number(found.id);
        return Number.isNaN(n) ? null : n;
    }, [ticketStatuses]);

    const pendenteStatusId = useMemo(() => {
        const list = ticketStatuses ?? [];
        const found = list.find((st) => st.name === 'Pendente');
        if (found?.id == null) return null;
        const n = Number(found.id);
        return Number.isNaN(n) ? null : n;
    }, [ticketStatuses]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        let scope = params.get('indScope');
        let sub = params.get('indSub');
        const fromQuery = Boolean(scope && sub);

        if (!fromQuery && location.state?.indicatorFilter) {
            scope = location.state.indicatorFilter.scope;
            sub = location.state.indicatorFilter.sub;
        }

        if (
            !scope ||
            !sub ||
            !IND_SHORTCUT_SCOPES.includes(scope) ||
            !IND_SHORTCUT_SUBS.includes(sub)
        ) {
            return;
        }

        setIndicatorShortcut({ scope, sub });
        props.setSelectedFilter(null);

        if (fromQuery) {
            history.replace({ pathname: location.pathname, search: '' });
        } else if (location.state?.indicatorFilter) {
            history.replace({ pathname: location.pathname, state: {} });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, location.key, location.state, location.pathname]);

    useEffect(() => {
        const tp = location.state?.ticketPanel;
        if (tp && Array.isArray(tp.ids)) {
            setPanelFilter({ label: tp.label || 'Painel', ids: tp.ids.map((n) => Number(n)) });
            setIndicatorShortcut(null);
            props.setSelectedFilter(null);
            // Limpa uma busca ativa: sem isso, o painel filtraria sobre os
            // resultados da busca (server-side) e poderia não achar os IDs.
            setSearchValue('');
            history.replace({ pathname: location.pathname, state: {} });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key, location.state, location.pathname]);

    const indicatorShortcutLabel = useMemo(() => {
        if (!indicatorShortcut) return '';
        const scopeMap = { my: 'Meus tickets', team: 'Minha equipe', all: 'Tickets gerais' };
        const subMap = {
            pending: 'Pendentes',
            new: 'Novos',
            inProgress: 'Em atendimento',
            stalled: 'Parados',
            openedToday: 'Abertos hoje',
        };
        const a = scopeMap[indicatorShortcut.scope];
        const b = subMap[indicatorShortcut.sub];
        if (!a || !b) return 'Indicadores';
        return `${a} · ${b}`;
    }, [indicatorShortcut]);

    const handleFilterApplied = (filterData) => {
        setIndicatorShortcut(null);
        if (filterData && typeof filterData === 'object') {
            props.setSelectedFilter(filterData);
            if (filterData.conditions && filterData.conditions.length > 0) {
                const filteredTickets = applyFilterConditions(props.tickets.tickets, filterData.conditions);
                setRows(filteredTickets);
            } else {
                setRows(props.tickets.tickets);
            }
        }
    };

    const handleClearFilter = () => {
        setIndicatorShortcut(null);
        props.setSelectedFilter(null);
    };


    const viewedTickets = useSelector(selectViewedTickets)

    useEffect(() => {
        if (!props.users || props.users.length === 0) {
            props.getUsers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        props.fetchFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.fetchFilters]);

    useEffect(() => {
        http.get('/ticket-statuses')
            .then((res) => setTicketStatuses(res?.data ?? []))
            .catch(() => setTicketStatuses([]));
    }, []);

    // Mapa `id -> parent_id` dos serviços, derivado da árvore que já é
    // buscada abaixo. É o que permite a condição por serviço casar a
    // DESCENDÊNCIA, igual ao servidor -- com a linha do chamado sozinha só
    // dá para ver um nível de pai, e a árvore tem quatro.
    const paiPorIdDoServico = useMemo(() => paiPorServico(services), [services]);

    // Serviços (árvore grupo -> subserviço) para a ação rápida "Alterar serviço".
    useEffect(() => {
        http.get('/services')
            .then((res) => setServices(Array.isArray(res.data) ? res.data : []))
            .catch(() => setServices([]));
    }, []);


    const handleActionsClick = useCallback((event, ticket) => {
        event.stopPropagation();
        setActionsAnchorEl(event.currentTarget);
        setActionsTicket(ticket);
    }, []);

    const getInitials = useCallback((name) => {
        if (!name) return '?';
        return name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
    }, []);

    // Recebe `number` (numero por tenant), nao a PK: a PK e global entre
    // empresas e nao pode ser o protocolo que o cliente ve.
    const formatProtocol = useCallback((numero) => {
        if (numero == null) return '-';
        return numero;
    }, []);

    const buildListActionsColumn = useCallback(() => {
        const isSm = isDefaultListSmDown;
        const minWidth = isSm ? 40 : 44;
        const flex = isSm ? 0.32 : 0.35;
        return {
            field: 'actions',
            headerName: '',
            flex,
            minWidth,
            sortable: false,
            renderCell: (params) => (
                <IconButton
                    size="small"
                    onClick={(e) => handleActionsClick(e, params.row)}
                    sx={{ color: theme.palette.text.secondary, p: 0.35 }}
                >
                    <MoreVert sx={{ fontSize: '1.1rem' }} />
                </IconButton>
            ),
        };
    }, [theme.palette.text.secondary, isDefaultListSmDown, handleActionsClick]);

    const handleCloseActionsMenu = () => {
        setActionsAnchorEl(null);
    };

    const isResolvedOrCancelled = (ticket) => [3, 4].includes(Number(ticket?.status));
    const canTransferTicket = (ticket) => ticket && !isResolvedOrCancelled(ticket);

    const handleOpenOptionsMenu = (event) => {
        setOptionsAnchorEl(event.currentTarget);
    };

    const handleCloseOptionsMenu = () => {
        setOptionsAnchorEl(null);
    };

    // Exportação server-side: pagina TODO o resultado no backend, SEM o
    // scope=active da listagem — assim tickets finalizados (Resolvido,
    // Cancelado, Fechado) entram na conferência. A listagem do quadro usa
    // scope=active e por isso não os contém; usá-la na exportação omitia os
    // resolvidos. Com tickets selecionados, exporta apenas eles.
    const resolveExportTickets = useCallback(async () => {
        if (selectedTicketIds.length > 0) {
            return rows.filter(r => selectedTicketIds.includes(r.id));
        }
        const term = (searchValue || '').trim();
        const all = [];
        let page = 1;
        let lastPage = 1;
        do {
            // `with_latest_comment` é o que preenche a coluna "Ultima ação do
            // ticket". O endpoint não carrega essa relação por padrão, de
            // propósito: ele também alimenta as listagens, e o corpo do
            // comentário de um chamado vindo de chat é a conversa inteira.
            // Só a exportação paga esse custo.
            const params = { per_page: 500, page, sort_by: 'created_at', sort_dir: 'desc', with_latest_comment: 1 };
            if (term.length >= 2) {
                params.search = term;
            }
            // eslint-disable-next-line no-await-in-loop
            const res = await http.get('/ticket/paginated', { params });
            const data = Array.isArray(res.data?.data) ? res.data.data : [];
            all.push(...data.map((t) => normalizeTicketAssigneeForList(t)));
            lastPage = res.data?.last_page || 1;
            page += 1;
        } while (page <= lastPage && page <= 40); // teto de segurança (~20k)
        // Respeita as condições do filtro selecionado (mesma regra da listagem).
        const conditions = props.selectedFilter?.conditions;
        if (Array.isArray(conditions) && conditions.length > 0) {
            return applyFilterConditions(all, conditions);
        }
        return all;
        // applyFilterConditions é definido adiante (TDZ) e só depende de props.users
        // (estável na sessão); incluí-lo no array quebraria a ordem de inicialização.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows, selectedTicketIds, searchValue, props.selectedFilter]);

    const ticketToFlatRow = useCallback(
        (ticket) => ticketToExportRow(ticket, props.selectedFilter, { mapStatus, mapPriority }),
        [props.selectedFilter]
    );

    const getExportHeaders = useCallback(
        () => getTicketExportColumns(props.selectedFilter, { mapStatus, mapPriority }).map((col) => col.header),
        [props.selectedFilter]
    );

    const downloadBlob = (filename, blob, mimeType) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    };

    /**
     * Envelope dos três handlers de exportação.
     *
     * Os três aguardam `resolveExportTickets()`, que vai à rede, e depois
     * montam o arquivo. Sem este envelope qualquer exceção rejeitava a
     * promise em SILÊNCIO -- nenhum arquivo, nenhum erro, nenhum aviso. O
     * operador clicava em exportar e simplesmente não acontecia nada, sem ter
     * como saber por quê.
     *
     * Não é hipotético: foi assim que o limite de célula do Excel (32.767
     * caracteres, estourado pela transcrição de um chat) passou despercebido
     * até alguém reparar que o arquivo nunca chegava.
     */
    const exportarAvisandoSeFalhar = async (formato, gerar) => {
        try {
            await gerar();
        } catch (erro) {
            console.error(`Falha ao exportar em ${formato}:`, erro);
            toast.error(`Não foi possível exportar em ${formato}. Veja o console para o motivo.`);
        }
    };

    const handleExportCSV = () => exportarAvisandoSeFalhar('CSV', async () => {
        handleCloseOptionsMenu();
        const tickets = await resolveExportTickets();
        if (tickets.length === 0) {
            toast.info('Nenhum ticket para exportar.');
            return;
        }
        const flat = tickets.map(ticketToFlatRow);
        const headers = getExportHeaders();
        const escape = (v) => {
            const s = String(v ?? '');
            if (s.includes(',') || s.includes('"') || s.includes('\n')) return `"${s.replace(/"/g, '""')}"`;
            return s;
        };
        const csv = [headers.map(escape).join(','), ...flat.map(r => headers.map(h => escape(r[h])).join(','))].join('\n');
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8' });
        downloadBlob(`tickets_${new Date().toISOString().slice(0, 10)}.csv`, blob, 'text/csv');
        toast.success(`${tickets.length} ticket(s) exportado(s) em CSV.`);
    });

    const handleExportXLSX = () => exportarAvisandoSeFalhar('XLSX', async () => {
        handleCloseOptionsMenu();
        const tickets = await resolveExportTickets();
        if (tickets.length === 0) {
            toast.info('Nenhum ticket para exportar.');
            return;
        }
        const flat = tickets.map(ticketToFlatRow);
        const ws = XLSX.utils.json_to_sheet(flat);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Tickets');
        XLSX.writeFile(wb, `tickets_${new Date().toISOString().slice(0, 10)}.xlsx`);
        toast.success(`${tickets.length} ticket(s) exportado(s) em XLSX.`);
    });

    const handleExportJSON = () => exportarAvisandoSeFalhar('JSON', async () => {
        handleCloseOptionsMenu();
        const tickets = await resolveExportTickets();
        if (tickets.length === 0) {
            toast.info('Nenhum ticket para exportar.');
            return;
        }
        const flat = tickets.map(ticketToFlatRow);
        const json = JSON.stringify(flat, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        downloadBlob(`tickets_${new Date().toISOString().slice(0, 10)}.json`, blob, 'application/json');
        toast.success(`${tickets.length} ticket(s) exportado(s) em JSON.`);
    });

    const handleOpenTransferModal = () => {
        if (!actionsTicket) return;

        const assignedId = actionsTicket.assigned_to?.id ?? actionsTicket.assigned_to;
        const defaultUser = props.users?.find(u => Number(u.id) === Number(assignedId)) || null;
        setTransferUser(defaultUser);
        setBulkTicketIds([]);
        setTransferModalOpen(true);
        handleCloseActionsMenu();
    };

    const handleOpenBulkTransferModal = () => {
        if (!selectedTicketIds.length) return;
        setBulkTicketIds(selectedTicketIds);
        setActionsTicket(null);
        setTransferUser(null);
        setTransferModalOpen(true);
        handleCloseOptionsMenu();
    };

    const handleCloseTransferModal = () => {
        setTransferModalOpen(false);
        setTransferUser(null);
        setActionsTicket(null);
        setBulkTicketIds([]);
    };

    // Exclusão em massa dos tickets selecionados (item 8). Gated por
    // #excluir-tickets; o backend também valida. Usa allSettled para não abortar
    // o lote se algum falhar (ex.: sem permissão / já removido).
    const handleBulkDelete = async () => {
        if (!selectedTicketIds.length) return;
        setBulkDeleting(true);
        try {
            const results = await Promise.allSettled(
                selectedTicketIds.map((id) => http.delete(`/ticket/${id}`))
            );
            const ok = results.filter((r) => r.status === 'fulfilled').length;
            const fail = results.length - ok;
            if (ok > 0) toast.success(`${ok} ticket(s) excluído(s).`);
            if (fail > 0) toast.error(`${fail} não excluído(s) (sem permissão ou já removido).`);
            setSelectedTicketIds([]);
            setBulkDeleteOpen(false);
            await props.fetchTickets();
        } catch (e) {
            toast.error('Erro ao excluir os tickets selecionados.');
        } finally {
            setBulkDeleting(false);
        }
    };

    // Aplica um PUT em cada ticket selecionado (ação rápida em massa). Reporta
    // sucessos/falhas por ticket (permissão/indisponibilidade caem em falha).
    const applyBulkUpdate = async (payload, successVerb) => {
        if (!selectedTicketIds.length) return;
        setBulkApplying(true);
        try {
            const results = await Promise.allSettled(
                selectedTicketIds.map((id) => http.put(`/ticket/${id}`, payload))
            );
            const ok = results.filter((r) => r.status === 'fulfilled').length;
            const fail = results.length - ok;
            if (ok > 0) toast.success(`${successVerb} em ${ok} ticket(s).`);
            if (fail > 0) toast.error(`${fail} não alterado(s) (sem permissão ou indisponível).`);
            setSelectedTicketIds([]);
            await props.fetchTickets();
        } catch (e) {
            toast.error('Erro ao aplicar a alteração.');
        } finally {
            setBulkApplying(false);
        }
    };

    const handleBulkApplyStatus = async () => {
        if (bulkStatusValue.statusId == null) { toast.warning('Selecione um status.'); return; }
        await applyBulkUpdate(
            { status_id: bulkStatusValue.statusId, substatus_id: bulkStatusValue.substatusId ?? null },
            'Status alterado'
        );
        setBulkStatusOpen(false);
    };

    const handleBulkApplyService = async () => {
        if (bulkServiceId == null) { toast.warning('Selecione um serviço.'); return; }
        await applyBulkUpdate({ service_id: bulkServiceId }, 'Serviço alterado');
        setBulkServiceOpen(false);
    };

    const handleConfirmTransfer = async () => {
        if (!transferUser) return;

        try {
            if (bulkTicketIds.length > 0) {
                const allTickets = props.tickets.tickets || [];
                await Promise.all(
                    bulkTicketIds.map(id => {
                        const ticket = allTickets.find(t => t.id === id);
                        if (!ticket) return null;
                        const payload = {
                            ...ticket,
                            assigned_to: transferUser.id
                        };
                        return props.editTicket(payload);
                    })
                );
                toast.success('Tickets transferidos com sucesso!');
                setSelectedTicketIds([]);
                setBulkTicketIds([]);
            } else if (actionsTicket) {
                const payload = {
                    ...actionsTicket,
                    assigned_to: transferUser.id
                };
                await props.editTicket(payload);
                toast.success('Ticket transferido com sucesso!');
            }
            handleCloseTransferModal();
        } catch (error) {
            // Erros de permissão já são tratados na action
        }
    };

    const handleOpenMergeModal = () => {
        if (!actionsTicket || !canMergeTickets) return;
        const preferred = localStorage.getItem('ticketMergePrimaryPreference');
        setMergePrimaryChoice(preferred === 'target' ? 'target' : 'current');
        setRememberMergeChoice(false);
        setMergeTargetTicket(null);
        setMergeModalOpen(true);
        handleCloseActionsMenu();
    };

    const handleCloseMergeModal = () => {
        setMergeModalOpen(false);
        setMergeTargetTicket(null);
        setRememberMergeChoice(false);
        setMergeSaving(false);
    };

    const handleConfirmMerge = async () => {
        if (!actionsTicket || !mergeTargetTicket) return;
        setMergeSaving(true);
        try {
            const primaryId = mergePrimaryChoice === 'target' ? mergeTargetTicket.id : actionsTicket.id;
            await http.post('/ticket/merge', {
                source_ticket_id: actionsTicket.id,
                target_ticket_id: mergeTargetTicket.id,
                primary_ticket_id: primaryId,
            });
            if (rememberMergeChoice) {
                localStorage.setItem('ticketMergePrimaryPreference', mergePrimaryChoice === 'target' ? 'target' : 'current');
            }
            toast.success('Tickets mesclados com sucesso.');
            await props.fetchTickets();
            handleCloseMergeModal();
        } catch (error) {
            const msg = error?.response?.data?.message || 'Não foi possível mesclar os tickets.';
            toast.error(msg);
            setMergeSaving(false);
        }
    };

    const handleRowClick = useCallback((ticket) => {
        const ticketExists = viewedTickets.some(t => t.id === ticket.id);
        
        if (ticketExists) {
            props.history.push(`/ticket/${ticket.id}`);
            return;
        }
        
        const limitReached = localStorage.getItem('quickAccessLimitReached') === 'true';
        if (limitReached) {
            props.history.push(`/ticket/${ticket.id}`);
            return;
        }
        
        const updatedViewedTickets = [...viewedTickets, ticket];
        props.setViewedTickets(updatedViewedTickets);
        props.history.push(`/ticket/${ticket.id}`);
    }, [viewedTickets, props]);

    const [dynamicColumns, setDynamicColumns] = useState([]);

    useEffect(() => {
        const generateDynamicColumns = (fields) => {
            if (!Array.isArray(fields)) return [];
            const columns = [];
            const dynFs = isDefaultListSmDown ? '0.68rem' : '0.72rem';
            const dynMinW = isDefaultListSmDown ? 60 : isDefaultListMdDown ? 66 : 72;
            const dynFlex = 0.85 * (isDefaultListSmDown ? 0.88 : isDefaultListMdDown ? 0.95 : 1);
            fields.forEach(field => {
                if (field.pivot && field.pivot.visible) {
                    columns.push({
                        field: field.id,
                        headerName: field.name,
                        flex: dynFlex,
                        minWidth: dynMinW,
                        renderCell: (params) => {
                            const fieldValue = valorDoCampoCustomizado(params.row, field.id);
                            return (
                                <Tooltip title={fieldValue} arrow placement='bottom' >
                                    <Typography variant="body2" sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: dynFs,
                                        lineHeight: 1.2,
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }} >
                                        {fieldValue}
                                    </Typography>
                                </Tooltip>
                            )
                        }
                    });
                }
            });

            const idMw = isDefaultListSmDown ? 38 : isDefaultListMdDown ? 44 : 50;
            const idFx = isDefaultListSmDown ? 0.24 : isDefaultListMdDown ? 0.32 : 0.4;
            columns.push({
                field: 'id', headerName: '', flex: idFx, minWidth: idMw,
                renderCell: (params) => {
                    const fs = isDefaultListSmDown ? '0.68rem' : '0.72rem';
                    return (
                        <Tooltip title={params.row.number} arrow placement='bottom' >
                            <Typography variant="body2" sx={{ fontSize: fs, color: theme.palette.text.primary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }} >
                                {formatProtocol(params.row.number)}
                            </Typography>
                        </Tooltip>
                    )
                }
            });

            return columns;
        };

        const generateStandardColumns = (standardFields) => {
            if (!Array.isArray(standardFields)) return [];
            const columns = [];

            const isMd = isDefaultListMdDown;
            const isSm = isDefaultListSmDown;
            const cellFs = isSm ? '0.68rem' : '0.72rem';
            /*
             * `whiteSpace: nowrap` ENTROU (ponto 23 da Gisele, 20/10/2026):
             * "alargar as informações da listagem para a descrição não quebrar
             * em duas linhas à toa".
             *
             * A reticência já estava aqui e nunca funcionou: `textOverflow`
             * só age sobre texto que NÃO quebra. Sem o `nowrap`, o assunto
             * quebrava em duas linhas e a reticência nunca aparecia -- e o
             * `Tooltip` em volta, que existe para mostrar o texto inteiro,
             * denunciava a intenção original.
             *
             * O efeito prático é o que ela pediu: uma linha por chamado, mesma
             * altura em todas, e mais chamados visíveis sem rolar.
             */
            const cellSm = estiloDeCelula(cellFs);

            const respLabelMinFlex = (fieldName, label, minW, flexVal) => {
                if (fieldName === 'id') {
                    return {
                        hdr: label,
                        minWidth: isSm ? 38 : isMd ? 44 : 50,
                        flex: isSm ? 0.24 : isMd ? 0.32 : 0.4,
                    };
                }
                const smLabels = {
                    id: 'Prot.',
                    title: 'Assunto',
                    status: 'Sit.',
                    status_id: 'Sit.',
                    priority: 'Prior.',
                    assigned_to: 'Resp.',
                    service_group_id: 'Grupo',
                    created_by: 'Criou',
                    client: 'Cliente',
                    category: 'Cat.',
                    product: 'Prod.',
                    service: 'Serviço',
                    representative: 'Rep.',
                    contact: 'Cont.',
                    channel: 'Canal',
                    is_internal: 'Tipo',
                    created_at: 'Abert.',
                    resolved_at: 'Resol.',
                    updated_at: 'Atual.',
                };
                const hdr = isSm ? (smLabels[fieldName] || label) : label;
                const minWidth = isSm ? Math.max(48, minW - 12) : isMd ? Math.max(50, minW - 8) : minW;
                const flex = flexVal * (isSm ? 0.9 : isMd ? 0.97 : 1);
                return { hdr, minWidth, flex };
            };

            const fieldMappings = {
                'id': {
                    label: 'Protocolo',
                    flex: 0.4,
                    minWidth: 50,
                    render: (params) => (
                        <Tooltip title={params.row.number} arrow placement='bottom'>
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.primary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                                {formatProtocol(params.row.number)}
                            </Typography>
                        </Tooltip>
                    )
                },
                'title': {
                    label: 'Assunto',
                    flex: 1.6,
                    minWidth: 110,
                    render: (params) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.1, py: 0, minWidth: 0 }}>
                            <Tooltip title={params.row.title} arrow placement='bottom'>
                                <Typography variant="body2" fontWeight={600} sx={{ ...cellSm, color: theme.palette.text.primary, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                    {params.row.title || '-'}
                                </Typography>
                            </Tooltip>
                            {/*
                              * Só o INTERNO aparece (ponto 28 da Gisele,
                              * 20/10: "melhorar o espaço de visualização da
                              * lista").
                              *
                              * "Público" é o caso comum, e escrevê-lo custava
                              * uma segunda linha em TODO chamado da listagem --
                              * metade da altura útil gasta repetindo o padrão.
                              * Marcar só a exceção devolve essa linha, e de
                              * quebra faz "Interno" saltar aos olhos, que é
                              * quando a informação muda alguma coisa.
                              *
                              * O dado não se perdeu: ele continua na coluna
                              * "Tipo" (quando visível), na busca, na exportação
                              * e na tela do chamado.
                              */}
                            {marcaDeTipo(params.row) && (
                                <Typography variant="caption" data-testid="marca-de-interno" sx={{ color: theme.palette.text.secondary, fontSize: isSm ? '0.6rem' : '0.65rem', lineHeight: 1.1 }}>
                                    {marcaDeTipo(params.row)}
                                </Typography>
                            )}
                        </Box>
                    )
                },
                'status': {
                    label: 'Status',
                    flex: 0.75,
                    minWidth: 68,
                    render: (params) => {
                        const statusLabel = params.row.ticket_status?.name || mapStatus(params.row.status);
                        const colors = TICKET_LIST_STATUS_CHIP_COLORS[statusLabel] || TICKET_LIST_STATUS_CHIP_COLORS.Pendente;
                        return (
                            <Chip
                                size="small"
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                                        <Box sx={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: colors.dot, flexShrink: 0 }} />
                                        <Box component="span" sx={{ fontSize: isSm ? '0.62rem' : '0.68rem', lineHeight: 1.15, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {statusLabel}
                                        </Box>
                                    </Box>
                                }
                                sx={{
                                    height: 22,
                                    maxWidth: '100%',
                                    backgroundColor: colors.bg,
                                    color: colors.dot,
                                    fontWeight: 500,
                                    '& .MuiChip-label': { px: 0.75, py: 0 },
                                }}
                            />
                        );
                    }
                },
                'priority': {
                    label: 'Prioridade',
                    flex: 0.7,
                    minWidth: 64,
                    render: (params) => {
                        const p = mapPriority(params.row.priority);
                        return (
                            <Typography variant="body2" sx={{ ...cellSm, color: TICKET_LIST_PRIORITY_TEXT_COLORS[p] || theme.palette.text.secondary }}>
                                {p}
                            </Typography>
                        );
                    }
                },
                'assigned_to': {
                    label: 'Responsável',
                    flex: 1.1,
                    minWidth: 88,
                    render: (params) => {
                        const name = getTicketAssigneeDisplayName(params.row, representantes);
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                <Avatar sx={{ width: isSm ? 20 : 22, height: isSm ? 20 : 22, fontSize: isSm ? '0.6rem' : '0.65rem', bgcolor: theme.palette.primary.main, flexShrink: 0 }}>
                                    {getInitials(name)}
                                </Avatar>
                                <Tooltip title={name} arrow placement='bottom'>
                                    <Typography variant="body2" fontWeight={500} sx={{ ...cellSm, color: theme.palette.text.primary, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                        {name}
                                    </Typography>
                                </Tooltip>
                            </Box>
                        );
                    }
                },
                'service_group_id': {
                    label: 'Grupo (responsável)',
                    flex: 0.9,
                    minWidth: 88,
                    render: (params) => {
                        const desc = params.row.assigned_to?.service_group?.description;
                        const sid = getTicketAssigneeServiceGroupId(params.row);
                        const text = desc || (sid != null ? `#${sid}` : '—');
                        return (
                            <Tooltip title={text} arrow placement='bottom'>
                                <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                                    {text}
                                </Typography>
                            </Tooltip>
                        );
                    }
                },
                'created_by': {
                    label: 'Criado por',
                    flex: 1.05,
                    minWidth: 88,
                    render: (params) => {
                        const name = params.row.created_by?.name || 'Sistema';
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                <Avatar sx={{ width: isSm ? 20 : 22, height: isSm ? 20 : 22, fontSize: isSm ? '0.6rem' : '0.65rem', bgcolor: theme.palette.primary.main, flexShrink: 0 }}>
                                    {getInitials(name)}
                                </Avatar>
                                <Tooltip title={name} arrow placement='bottom'>
                                    <Typography variant="body2" fontWeight={500} sx={{ ...cellSm, color: theme.palette.text.secondary, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                        {name}
                                    </Typography>
                                </Tooltip>
                            </Box>
                        );
                    }
                },
                'client': {
                    label: 'Cliente',
                    flex: 1.05,
                    minWidth: 88,
                    render: (params) => {
                        const text = formatTicketClientDisplay(params.row) || 'Não informado';
                        return (
                            <Tooltip title={text} arrow placement='bottom'>
                                <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                                    {text}
                                </Typography>
                            </Tooltip>
                        );
                    }
                },
                'category': {
                    label: 'Categoria',
                    flex: 0.85,
                    minWidth: 72,
                    render: (params) => (
                        <Tooltip title={params.row.category || 'Não informado'} arrow placement='bottom' >
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary }} >
                                {params.row.category || 'Não informado'}
                            </Typography>
                        </Tooltip>
                    )
                },
                'product': {
                    label: 'Produto',
                    flex: 0.85,
                    minWidth: 72,
                    render: (params) => {
                        const text = getTicketProduct(params.row) || 'Não informado';
                        return (
                            <Tooltip title={text} arrow placement='bottom'>
                                <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                                    {text}
                                </Typography>
                            </Tooltip>
                        );
                    }
                },
                'service': {
                    label: 'Serviço',
                    flex: 1.1,
                    minWidth: 96,
                    render: (params) => {
                        const text = getTicketServiceLabel(params.row) || 'Não informado';
                        return (
                            <Tooltip title={text} arrow placement='bottom'>
                                <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                                    {text}
                                </Typography>
                            </Tooltip>
                        );
                    }
                },
                'representative': {
                    label: 'Representante',
                    flex: 1.05,
                    minWidth: 88,
                    render: (params) => {
                        const text = getTicketRepresentative(params.row) || 'Não informado';
                        return (
                            <Tooltip title={text} arrow placement='bottom'>
                                <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                                    {text}
                                </Typography>
                            </Tooltip>
                        );
                    }
                },
                'contact': {
                    label: 'Contato',
                    flex: 0.85,
                    minWidth: 72,
                    render: (params) => (
                        <Tooltip title={params.row.contact || 'Não informado'} arrow placement='bottom' >
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary }} >
                                {params.row.contact || 'Não informado'}
                            </Typography>
                        </Tooltip>
                    )
                },
                'channel': {
                    label: 'Canal',
                    flex: 0.85,
                    minWidth: 72,
                    render: (params) => (
                        <Tooltip title={params.row.channel || 'Não informado'} arrow placement='bottom' >
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary }} >
                                {params.row.channel || 'Não informado'}
                            </Typography>
                        </Tooltip>
                    )
                },
                'is_internal': {
                    label: 'Tipo',
                    flex: 0.55,
                    minWidth: 56,
                    render: (params) => {
                        const internal = Boolean(params.row.is_internal);
                        return (
                            <Tooltip title={internal ? 'Interno' : 'Público'} arrow placement="bottom">
                                <Chip
                                    size="small"
                                    label={internal ? 'Interno' : 'Público'}
                                    sx={{
                                        height: 22,
                                        maxWidth: '100%',
                                        fontWeight: 600,
                                        fontSize: isSm ? '0.62rem' : '0.68rem',
                                        backgroundColor: internal ? 'rgba(255, 152, 0, 0.15)' : 'rgba(76, 175, 80, 0.15)',
                                        color: internal ? '#E65100' : '#2E7D32',
                                        '& .MuiChip-label': { px: 0.75, py: 0 },
                                    }}
                                />
                            </Tooltip>
                        );
                    }
                },
                'created_at': {
                    label: 'Data de abertura',
                    flex: 0.95,
                    minWidth: 100,
                    render: (params) => (
                        <Tooltip title={formatTicketDateTime(params.row.created_at) || '—'} arrow placement="bottom">
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary }} >
                                {formatTicketDateTimeCompact(params.row.created_at) || '—'}
                            </Typography>
                        </Tooltip>
                    )
                },
                'resolved_at': {
                    label: 'Data de resolução',
                    flex: 0.95,
                    minWidth: 100,
                    render: (params) => (
                        <Tooltip title={formatTicketDateTime(params.row.resolved_at) || '—'} arrow placement="bottom">
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary }} >
                                {formatTicketDateTimeCompact(params.row.resolved_at) || '—'}
                            </Typography>
                        </Tooltip>
                    )
                },
                'updated_at': {
                    label: 'Data de Atualização',
                    flex: 0.95,
                    minWidth: 100,
                    render: (params) => (
                        <Tooltip title={formatTicketDateTime(params.row.updated_at) || '—'} arrow placement="bottom">
                            <Typography variant="body2" sx={{ ...cellSm, color: theme.palette.text.secondary }} >
                                {formatTicketDateTimeCompact(params.row.updated_at) || '—'}
                            </Typography>
                        </Tooltip>
                    )
                }
            };

            // A API (FilterService) publica o campo de status como 'status_id', mas o
            // mapeamento aqui sempre usou 'status'. Sem o alias, marcar "Status" na
            // configuracao do filtro era ignorado em silencio na listagem.
            fieldMappings['status_id'] = fieldMappings['status'];

            standardFields.forEach(field => {
                if (field.visible && fieldMappings[field.name]) {
                    const mapping = fieldMappings[field.name];
                    const r = respLabelMinFlex(field.name, mapping.label, mapping.minWidth, mapping.flex);
                    columns.push({
                        field: field.name,
                        headerName: field.name === 'id' ? '' : r.hdr,
                        flex: r.flex,
                        minWidth: r.minWidth,
                        renderCell: (params) => mapping.render(params)
                    });
                }
            });

            return columns;
        };

        if (props.selectedFilter && typeof props.selectedFilter === 'object') {
            const customColumns = props.selectedFilter.fields ? generateDynamicColumns(props.selectedFilter.fields) : [];

            const standardColumns = props.selectedFilter.settings?.standard_fields ?
                generateStandardColumns(props.selectedFilter.settings.standard_fields) : [];

            const merged = [...customColumns, ...standardColumns];
            const viewType = props.selectedFilter.settings?.view_type || 'list';
            if (viewType !== 'kanban' && !merged.some((c) => c && c.field === 'actions')) {
                merged.push(buildListActionsColumn());
            }
            setDynamicColumns(merged);
        } else {
            setDynamicColumns([]);
        }
    }, [
        // Sem esta dependencia o mapa chegaria DEPOIS e as colunas nao
        // recalculariam -- o representante so apareceria quando outra coisa
        // forcasse o recalculo.
        representantes,
        props.selectedFilter,
        handleRowClick,
        theme.palette.text.primary,
        theme.palette.text.secondary,
        theme.palette.primary.main,
        isDefaultListMdDown,
        isDefaultListSmDown,
        buildListActionsColumn,
        formatProtocol,
        getInitials,
    ]);

    const mapTicketToSearchString = (ticket) => {
        const statusString = mapStatus(ticket.status);
        const priorityString = mapPriority(ticket.priority);
        const typeString = ticket.is_internal ? 'Interno' : 'Público';
        /*
         * Os TRÊS números do chamado, não só o `id`.
         *
         * A regra mora em `utils/numerosDoChamado`, com teste: o refinamento
         * no navegador não pode descartar a linha que o servidor encontrou,
         * senão a busca acha e a tela esconde.
         */
        const protocol = numerosDoChamado(ticket);
        const openStr = formatTicketDateTime(ticket.created_at);
        const resolvedStr = formatTicketDateTime(ticket.resolved_at);
        const sgLabel = ticket.assigned_to?.service_group?.description || '';
        /*
         * `textoDeBuscaDoCliente`, e não o rótulo: o rótulo escolhe UM nome,
         * e o servidor procura pelo registro, pela razão social E pelo nome
         * fantasia. Com o rótulo aqui, a linha que o servidor acabou de
         * encontrar era escondida pela tela.
         */
        return `${protocol} ${ticket.title} ${ticket.description} ${statusString} ${priorityString} ${getTicketAssigneeDisplayName(ticket, representantes)} ${sgLabel} ${ticket.created_by?.name || ''} ${textoDeBuscaDoCliente(ticket)} ${ticket.category || ''} ${ticket.contact || ''} ${ticket.channel || ''} ${typeString} ${openStr} ${resolvedStr}`;
    };

    const applyOperator = useCallback((ticketValue, filterValue, operator) => {
        /*
         * "É um de" / "Não é um de" vem ANTES do descarte de nulo abaixo, e
         * não depois.
         *
         * O servidor inclui o chamado sem valor no "não é um de" -- ele de
         * fato não é nenhum dos escolhidos. Se esta avaliação o descartasse
         * por ser nulo, o servidor traria as linhas certas e a tela apagaria
         * parte delas. A regra mora em `utils/condicaoDeLista`, com teste.
         */
        const deLista = avaliarOperadorDeLista(ticketValue, filterValue, operator);
        if (deLista !== null) return deLista;

        if (ticketValue === null || ticketValue === undefined) {
            return operator === 'is_null';
        }

        const ticketNum = typeof ticketValue === 'number' ? ticketValue : (!isNaN(ticketValue) && ticketValue !== '' ? Number(ticketValue) : null);
        const filterNum = typeof filterValue === 'number' ? filterValue : (!isNaN(filterValue) && filterValue !== '' ? Number(filterValue) : null);
        
        const useNumericComparison = ticketNum !== null && filterNum !== null && !isNaN(ticketNum) && !isNaN(filterNum);

        switch (operator) {
            case 'equals':
                if (useNumericComparison) {
                    return ticketNum === filterNum;
                }
                return ticketValue === filterValue || String(ticketValue) === String(filterValue);
            case 'not_equals':
                if (useNumericComparison) {
                    return ticketNum !== filterNum;
                }
                return ticketValue !== filterValue && String(ticketValue) !== String(filterValue);
            case 'contains':
                return ticketValue && ticketValue.toString().includes(filterValue);
            case 'not_contains':
                return !ticketValue || !ticketValue.toString().includes(filterValue);
            case 'starts_with':
                return ticketValue && ticketValue.toString().startsWith(filterValue);
            case 'ends_with':
                return ticketValue && ticketValue.toString().endsWith(filterValue);
            case 'is_null':
                return ticketValue === null || ticketValue === undefined;
            case 'is_not_null':
                return ticketValue !== null && ticketValue !== undefined;
            default:
                return true;
        }
    }, []);

    const applyFilterConditions = useCallback((tickets, conditions) => {
        if (!conditions || conditions.length === 0) return tickets;

        // Modelo de dois grupos (Movidesk): combinadas (E) + independentes (OU).
        // Passa se: todas as combinadas batem E (não há independentes OU ao menos uma bate).
        const isIndep = (c) => (c.logic_group || 'combined') === 'independent';
        const combined = conditions.filter((c) => !isIndep(c));
        const independent = conditions.filter(isIndep);

        const matchOne = (ticket, condition) => {
                const field = condition.field_name || condition.field;
                const value = condition.value;
                const operator = condition.operator || 'equals';

                switch (field) {
                    case 'status_id': {
                        // "Não concluído" ANTES de qualquer conversão: o
                        // marcador é texto, `Number(marcador)` é `NaN`, e
                        // toda comparação abaixo seria falsa -- a tela
                        // mostraria "nenhum ticket" com o servidor
                        // devolvendo os certos.
                        const dinamico = avaliarValorDinamico({
                            campo: 'status_id',
                            valor: value,
                            ticket,
                            usuarioAtual: props.currentUser,
                            finalizados: idsDeStatusFinalizados,
                        });
                        if (dinamico !== null) {
                            return operator === 'not_equals' ? !dinamico : dinamico;
                        }
                        // Status real (configurável). Aceita value único ou lista (in/not_in).
                        const ticketSid = ticket.status_id ?? ticket.ticket_status?.id ?? ticket.ticketStatus?.id ?? null;
                        const toNum = (v) => (v === '' || v == null ? v : Number(v));
                        if (operator === 'in' || operator === 'not_in') {
                            let arr = value;
                            if (typeof value === 'string') {
                                try { arr = JSON.parse(value); } catch { arr = value.split(',').map((s) => s.trim()); }
                            }
                            const list = (Array.isArray(arr) ? arr : [arr]).map(toNum);
                            const hit = ticketSid != null && list.some((v) => Number(v) === Number(ticketSid));
                            return operator === 'in' ? hit : !hit;
                        }
                        if (operator === 'is_null') return ticketSid == null;
                        if (operator === 'is_not_null') return ticketSid != null;
                        const sv = toNum(value);
                        if (operator === 'not_equals') return Number(ticketSid) !== Number(sv);
                        return Number(ticketSid) === Number(sv);
                    }
                    case 'status':
                        let statusValue;
                        if (typeof value === 'number') {
                            statusValue = value;
                        } else if (value !== null && value !== undefined && value !== '') {
                            statusValue = Number(value);
                            if (isNaN(statusValue)) {
                                statusValue = value;
                            }
                        } else {
                            statusValue = value;
                        }
                        
                        let ticketStatus;
                        if (typeof ticket.status === 'number') {
                            ticketStatus = ticket.status;
                        } else if (ticket.status !== null && ticket.status !== undefined && ticket.status !== '') {
                            ticketStatus = Number(ticket.status);
                            if (isNaN(ticketStatus)) {
                                ticketStatus = ticket.status;
                            }
                        } else {
                            ticketStatus = ticket.status;
                        }
                        
                        if (operator === 'equals') {
                            return ticketStatus === statusValue;
                        }
                        
                        return applyOperator(ticketStatus, statusValue, operator);
                        
                    case 'priority':
                        let priorityValue;
                        if (typeof value === 'number') {
                            priorityValue = value;
                        } else if (value !== null && value !== undefined && value !== '') {
                            priorityValue = Number(value);
                            if (isNaN(priorityValue)) {
                                priorityValue = value;
                            }
                        } else if (value === 0 || value === '0') {
                            priorityValue = 0;
                        } else {
                            priorityValue = value;
                        }
                        
                        let ticketPriority;
                        if (typeof ticket.priority === 'number') {
                            ticketPriority = ticket.priority;
                        } else if (ticket.priority !== null && ticket.priority !== undefined && ticket.priority !== '') {
                            ticketPriority = Number(ticket.priority);
                            if (isNaN(ticketPriority)) {
                                ticketPriority = ticket.priority;
                            }
                        } else if (ticket.priority === 0 || ticket.priority === '0') {
                            ticketPriority = 0;
                        } else {
                            ticketPriority = ticket.priority;
                        }
                        
                        if (operator === 'equals') {
                            return ticketPriority === priorityValue;
                        }
                        
                        return applyOperator(ticketPriority, priorityValue, operator);
                    case 'assigned_to': {
                        // Valor dinâmico ANTES do resto: `isNaN(marcador)` é
                        // verdadeiro, então sem isto a comparação cairia no
                        // ramo de TEXTO e mediria o marcador contra o NOME do
                        // responsável -- nunca casando, e a tela mostrando
                        // "nenhum ticket" com o servidor devolvendo os certos.
                        const dinamico = avaliarValorDinamico({
                            campo: 'assigned_to', valor: value, ticket, usuarioAtual: props.currentUser,
                        });
                        if (dinamico !== null) {
                            return operator === 'not_equals' ? !dinamico : dinamico;
                        }
                        if (isNaN(value)) {
                            return applyOperator(getTicketAssigneeDisplayName(ticket, representantes)?.toLowerCase(), value?.toLowerCase(), operator);
                        } else {
                            return applyOperator(ticket.assigned_to?.id, parseInt(value), operator);
                        }
                    }
                    case 'service_group_id': {
                        // Antes do `parseInt`, que no marcador dá `NaN` e
                        // faria toda comparação ser falsa.
                        const dinamico = avaliarValorDinamico({
                            campo: 'service_group_id', valor: value, ticket, usuarioAtual: props.currentUser,
                        });
                        if (dinamico !== null) {
                            return operator === 'not_equals' ? !dinamico : dinamico;
                        }
                        const sg = getTicketAssigneeServiceGroupId(ticket);
                        const intVal = parseInt(value, 10);
                        if (operator === 'equals') {
                            return sg != null && Number(sg) === intVal;
                        }
                        if (operator === 'not_equals') {
                            return sg == null || Number(sg) !== intVal;
                        }
                        if (operator === 'is_null') {
                            return sg == null;
                        }
                        if (operator === 'is_not_null') {
                            return sg != null;
                        }
                        if (operator === 'in') {
                            let arr = value;
                            if (typeof value === 'string' && value.trim() !== '') {
                                try {
                                    arr = JSON.parse(value);
                                } catch {
                                    arr = value.split(',').map((s) => s.trim()).filter(Boolean);
                                }
                            }
                            if (!Array.isArray(arr)) arr = [arr];
                            const ids = arr.map((x) => Number(x)).filter((n) => !Number.isNaN(n));
                            return sg != null && ids.includes(Number(sg));
                        }
                        if (operator === 'not_in') {
                            let arr = value;
                            if (typeof value === 'string' && value.trim() !== '') {
                                try {
                                    arr = JSON.parse(value);
                                } catch {
                                    arr = value.split(',').map((s) => s.trim()).filter(Boolean);
                                }
                            }
                            if (!Array.isArray(arr)) arr = [arr];
                            const ids = arr.map((x) => Number(x)).filter((n) => !Number.isNaN(n));
                            return sg == null || !ids.includes(Number(sg));
                        }
                        return applyOperator(sg, intVal, operator);
                    }
                    case 'created_by': {
                        const dinamico = avaliarValorDinamico({
                            campo: 'created_by', valor: value, ticket, usuarioAtual: props.currentUser,
                        });
                        if (dinamico !== null) {
                            return operator === 'not_equals' ? !dinamico : dinamico;
                        }
                        if (isNaN(value)) {
                            return applyOperator(ticket.created_by?.name?.toLowerCase(), value?.toLowerCase(), operator);
                        } else {
                            return applyOperator(ticket.created_by?.id, parseInt(value), operator);
                        }
                    }
                    case 'client':
                        return applyOperator(formatTicketClientDisplay(ticket)?.toLowerCase(), value?.toLowerCase(), operator);
                    case 'cc_users':
                        const ticketCcUsers = ticket.cc_users || [];
                        if (isNaN(value)) {
                            // Se value é um nome, buscar usuário e verificar se está em cc_users
                            const user = props.users?.find(u => u.name?.toLowerCase() === value?.toLowerCase());
                            if (user) {
                                return applyOperator(ticketCcUsers.includes(user.id), true, operator);
                            }
                            return false;
                        } else {
                            // Se value é um ID, verificar diretamente
                            return applyOperator(ticketCcUsers.includes(parseInt(value)), true, operator);
                        }
                    case 'service': {
                        // O servidor, ao filtrar por um serviço, inclui toda a
                        // DESCENDÊNCIA dele -- a árvore tem quatro níveis e os
                        // chamados ficam nas folhas. Sem reproduzir isso aqui,
                        // ele devolveria as linhas certas e a tela descartaria
                        // todas: "nenhum ticket encontrado" sem erro nenhum,
                        // que foi o que aconteceu com os valores dinâmicos em
                        // 08/10.
                        //
                        // A comparação sobe a partir do chamado em vez de
                        // descer a partir do escolhido: mesma resposta, e
                        // custa o tamanho da cadeia (quatro) em vez do da
                        // subárvore (dezenas), por linha da lista.
                        const escolhidos = (() => {
                            if (Array.isArray(value)) return value;
                            if (typeof value === 'string' && value.trim() !== '') {
                                try {
                                    const lido = JSON.parse(value);
                                    return Array.isArray(lido) ? lido : [lido];
                                } catch {
                                    return value.split(',').map((s) => s.trim()).filter(Boolean);
                                }
                            }
                            return value == null || value === '' ? [] : [value];
                        })();

                        const casa = escolhidos.some((um) => chamadoNoServico(ticket, um, paiPorIdDoServico));

                        return (operator === 'not_equals' || operator === 'not_in') ? !casa : casa;
                    }
                    case 'category':
                        return applyOperator(ticket.category?.toLowerCase(), value?.toLowerCase(), operator);
                    case 'product':
                        return applyOperator(getTicketProduct(ticket)?.toLowerCase(), value?.toLowerCase?.(), operator);
                    case 'representative':
                        return applyOperator(getTicketRepresentative(ticket)?.toLowerCase(), value?.toLowerCase?.(), operator);
                    case 'is_internal':
                        const boolValue = value === 'true' || value === true || value === 1;
                        return applyOperator(ticket.is_internal, boolValue, operator);
                    case 'title':
                        return applyOperator(ticket.title?.toLowerCase(), value?.toLowerCase(), operator);
                    case 'description':
                        return applyOperator(ticket.description?.toLowerCase(), value?.toLowerCase(), operator);
                    case 'created_at': {
                        const v = Array.isArray(value) && value.length === 1 ? value[0] : value;
                        return applyTicketDateCondition(ticket.created_at, operator, v);
                    }
                    case 'resolved_at': {
                        const v = Array.isArray(value) && value.length === 1 ? value[0] : value;
                        return applyTicketDateCondition(ticket.resolved_at, operator, v);
                    }
                    case 'updated_at': {
                        const v = Array.isArray(value) && value.length === 1 ? value[0] : value;
                        return applyTicketDateCondition(ticket.updated_at, operator, v);
                    }
                    default:
                        return true;
                }
        };

        return tickets.filter(ticket => {
            const combinedOk = combined.every((c) => matchOne(ticket, c));
            const independentOk = independent.length === 0 || independent.some((c) => matchOne(ticket, c));
            return combinedOk && independentOk;
        });
        // `idsDeStatusFinalizados`, `paiPorIdDoServico` e `props.currentUser`
        // são lidos por dentro, nos valores dinâmicos e na condição de
        // serviço, e FALTAVAM aqui. Sem eles a avaliação fica congelada no
        // primeiro render: se os status, a árvore de serviços ou o usuário
        // chegam depois, "Não concluído" nunca passa a distinguir concluído
        // de aberto, o serviço volta a casar só igualdade exata e "Agente
        // logado" avalia contra usuário indefinido. Em nenhum dos casos
        // aparece erro -- aparece lista errada.
    }, [applyOperator, props.users, representantes, idsDeStatusFinalizados, paiPorIdDoServico, props.currentUser]);

    /*
     * Estes dois sobem para cá porque a BUSCA passou a precisar deles.
     *
     * Ficavam declarados mais abaixo, e um `const` só existe a partir da linha
     * em que é declarado: citá-los na lista de dependências de um `useCallback`
     * acima daria erro de inicialização na renderização, não em tempo de uso.
     */

    // Filtro salvo aplicado no SERVIDOR (suas condições). Só faz sentido quando
    // o filtro tem condições; senão é "mostrar tudo" e não precisa restringir.
    const serverFilterId = (props.selectedFilter?.conditions?.length > 0) ? (props.selectedFilter?.id ?? null) : null;

    /*
     * As condições da Busca Avançada que o SERVIDOR sabe reproduzir.
     *
     * Memoizadas porque entram como dependência de efeitos: um array novo a
     * cada render recarregaria a página em laço.
     *
     * Elas não decidem o que a tela mostra -- `applyAdvancedSearchFilters`
     * continua decidindo. Decidem o que BAIXAR. Ver
     * `utils/condicoesDaBuscaAvancada`.
     */
    const condicoesDoServidor = useMemo(
        () => condicoesDaBuscaAvancada(advancedSearchFilters),
        [advancedSearchFilters]
    );

    // Busca server-side paginada: busca o backend (inclui o histórico fechado).
    // page<=1 substitui; page>1 acumula (scroll infinito).
    const fetchSearchPage = useCallback((term, page) => {
        if (searchLoadingRef.current) return;
        searchLoadingRef.current = true;
        comecouBuscaNoServidor();

        /*
         * A busca leva o FILTRO SALVO junto.
         *
         * Sem `filter_id` -- como era até 19/10/2026 -- buscar dentro de um
         * kanban devolvia chamado da base inteira: o servidor não tinha como
         * saber em qual kanban a pessoa estava. O sintoma que a Gisele
         * relatou foi o visível ("aparece nome de outros operadores que não
         * pertencem a este kanban"), mas o estrago é maior: os RESULTADOS
         * também vinham de fora do filtro.
         *
         * As condições da busca avançada entram pelo mesmo motivo, e é o
         * mesmo tratamento que a listagem e os contadores já recebem.
         */
        const params = { search: term, per_page: 100, page, sort_by: 'created_at', sort_dir: 'desc' };
        if (serverFilterId) {
            params.filter_id = serverFilterId;
            /*
             * incluir_sem_responsavel, pelo mesmo motivo do agregado de
             * responsáveis e da paginação dos grupos -- e era o que faltava
             * aqui.
             *
             * A condição de grupo de atendimento do filtro salvo é, no
             * servidor, "o RESPONSÁVEL é do grupo X" (`FilterService::
             * applyAssigneeServiceGroupCondition`). Chamado sem responsável
             * não tem responsável de grupo nenhum, então o servidor o
             * descartava -- mesmo quando o `service_group_id` do próprio
             * chamado é o grupo do filtro, que é por onde o NAVEGADOR o
             * aceita (`getTicketAssigneeServiceGroupId`: sem responsável,
             * cai no grupo do chamado).
             *
             * Resultado medido em produção em 27/10/2026: o chamado 267230
             * estava à vista no Kanban Comercial e a busca por "267230"
             * dentro dele voltava VAZIA -- `filter_id=23&search=267230` dava
             * 0, e com esta flag dá 2. Foi o relato da Gisele.
             *
             * Isto decide o que BAIXAR, não o que a tela mostra: as condições
             * do filtro salvo continuam sendo reavaliadas no navegador sobre
             * o que chegou, então chamado sem responsável de OUTRO
             * departamento vem e é descartado aqui.
             */
            params.incluir_sem_responsavel = 1;
        }
        if (condicoesDoServidor.length) params.conditions = condicoesDoServidor;

        http.get('/ticket/paginated', { params })
            .then((res) => {
                const data = (res.data?.data || []).map((t) => normalizeTicketAssigneeForList(t));
                setServerSearchResults((prev) => {
                    if (page <= 1 || !Array.isArray(prev)) return data;
                    const ids = new Set(prev.map((p) => p.id));
                    return [...prev, ...data.filter((d) => !ids.has(d.id))];
                });
                setSearchMeta({ page: res.data?.current_page || page, lastPage: res.data?.last_page || 1 });
            })
            .catch(() => {
                if (page <= 1) setServerSearchResults([]);
            })
            .finally(() => { searchLoadingRef.current = false; terminouBuscaNoServidor(); });
    }, [serverFilterId, condicoesDoServidor, comecouBuscaNoServidor, terminouBuscaNoServidor]);

    /*
     * "Texto na ação" também liga a busca no servidor, mesmo sem nada digitado
     * na caixa de pesquisa.
     *
     * É o único campo da Busca Avançada que o navegador não sabe avaliar: a
     * listagem traz o chamado, não as ações dele. Sem este gatilho, a condição
     * iria para o servidor mas a tela continuaria montando a lista a partir
     * dos ATIVOS que já tem em memória -- e todos eles apareceriam, sem passar
     * por filtro nenhum. O campo pareceria não funcionar.
     *
     * Com o gatilho, a lista passa a vir do resultado do servidor, que é onde
     * a condição foi aplicada -- e de quebra alcança o chamado fechado, que é
     * justamente onde se procura uma frase escrita meses atrás.
     */
    const textoNaAcao = (advancedSearchFilters?.textoNaAcao || '').trim();

    // Ao digitar, dispara a primeira página (com debounce).
    useEffect(() => {
        const term = (searchValue || '').trim();
        if (term.length < 2 && textoNaAcao.length < 2) {
            setServerSearchResults(null);
            setSearchMeta({ page: 0, lastPage: 0 });
            return undefined;
        }
        const t = setTimeout(() => { fetchSearchPage(term, 1); }, 350);
        return () => clearTimeout(t);
    }, [searchValue, textoNaAcao, fetchSearchPage]);

    // Scroll infinito da busca (lista e kanban): ao chegar perto do fim, carrega
    // a próxima página dos resultados. O wrapper rola (DataGrid usa autoHeight).
    useEffect(() => {
        if (serverSearchResults == null) return undefined;
        const el = tableWrapperRef.current;
        if (!el) return undefined;
        const onScroll = () => {
            if (el.scrollTop + el.clientHeight < el.scrollHeight - 350) return;
            if (searchLoadingRef.current) return;
            if (searchMeta.page > 0 && searchMeta.page < searchMeta.lastPage) {
                fetchSearchPage((searchValue || '').trim(), searchMeta.page + 1);
            }
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, [serverSearchResults, searchMeta, searchValue, fetchSearchPage]);

    const viewMode = props.selectedFilter?.settings?.view_type === 'kanban' ? 'kanban' : 'list';

    // Status finalizados (Fechado/Cancelado/Resolvido) — excluídos do scope=active
    // da listagem. A lista vem de `idsDeStatusFinalizados`, declarado uma vez
    // no alto: aqui havia uma SEGUNDA derivação, com o array de nomes
    // escrito à mão, e a api já tem a dela
    // (`TicketStatus::NOMES_FINALIZADOS`). Duas cópias da mesma lista
    // divergem sem dar erro -- a tela só passa a esconder chamados.

    /*
     * status_id finalizados que o filtro selecionado referencia. Só esses
     * precisam ser buscados sob demanda.
     *
     * Mora em `utils/finalizadosDoFiltro`, e não aqui: a conta estava
     * ignorando o OPERADOR da condição, o que invertia todo filtro negativo --
     * "não é um de [Novo, Aberto, Em atendimento]", que é como se escreve "só
     * o histórico", não baixava finalizado nenhum (ponto 33 da Gisele). Num
     * arquivo de 6 mil linhas sem teste, isso não tinha como ser pego.
     *
     * NÃO consideramos as `kanban_columns`: na LISTAGEM elas são irrelevantes
     * e costumam referenciar TODOS os status. Incluí-las fazia a lista
     * carregar todos os finalizados (Fechado domina), e a condição (ex.:
     * status=Cancelado) descartava a 1ª página inteira -> 0 tickets. Aqui vale
     * só o que as CONDIÇÕES do filtro pedem.
     */
    const filterFinalizedStatusIds = useMemo(
        () => finalizadosReferenciados(
            props.selectedFilter,
            idsDeStatusFinalizados,
            advancedSearchFilters?.status,
        ),
        [props.selectedFilter, idsDeStatusFinalizados, advancedSearchFilters],
    );

    // O filtro tem condição de status? Se sim, respeitamos; se não, é "mostrar tudo".
    const filterHasStatusCondition = useMemo(
        () => temCondicaoDeStatus(props.selectedFilter, advancedSearchFilters?.status),
        [props.selectedFilter, advancedSearchFilters],
    );

    // Finalizados a carregar na LISTAGEM: os que o filtro referencia; ou, se o
    // filtro não tem condição de status (mostra tudo), TODOS os finalizados.
    const listFinalizedStatusIds = useMemo(() => {
        if (filterFinalizedStatusIds.length > 0) return filterFinalizedStatusIds;
        if (!filterHasStatusCondition) return idsDeStatusFinalizados;
        return [];
    }, [filterFinalizedStatusIds, filterHasStatusCondition, idsDeStatusFinalizados]);

    // Carga PAGINADA dos finalizados na listagem plana (no kanban quem carrega é o
    // groupExtra, por responsável×coluna). 1ª página no início; o scroll busca as
    // próximas. Nada de bulk — cada página são 100, por updated_at (índice Fase 0).
    const FINALIZED_PAGE_SIZE = 100;
    const [finalizedExtra, setFinalizedExtra] = useState([]);
    const [finalizedPage, setFinalizedPage] = useState(1);
    const [finalizedHasMore, setFinalizedHasMore] = useState(false);
    const finalizedLoadingRef = useRef(false);
    // `serverFilterId` subiu para junto da busca, que passou a precisar dele.
    const finalizedKey = viewMode === 'kanban' ? '' : listFinalizedStatusIds.slice().sort((a, b) => a - b).join(',');

    const loadFinalizedPage = useCallback((ids, page, reset, filterId, condicoes) => {
        if (finalizedLoadingRef.current || !ids.length) return;
        finalizedLoadingRef.current = true;
        const params = { status_id: ids, per_page: FINALIZED_PAGE_SIZE, page, sort_by: 'updated_at', sort_dir: 'desc' };
        // filter_id => o backend aplica as CONDIÇÕES do filtro (grupo de atendimento,
        // produto, prioridade...) no servidor. Sem isso, um match raro fora da 1ª
        // página (ex.: único cancelado do grupo Suporte) nunca aparecia na listagem,
        // pois o filtro por grupo só rodava client-side sobre a página carregada.
        if (filterId) params.filter_id = filterId;
        /*
         * conditions => o MESMO conserto, agora para a Busca Avançada.
         *
         * Ela ficou de fora quando o `filter_id` foi resolvido, e pelo mesmo
         * motivo o defeito sobreviveu: ela refina no navegador sobre o que já
         * está carregado -- os não finalizados mais os 100 finalizados mais
         * recentes. Um chamado fechado há meses que casa o filtro nunca
         * chegava na tela, e o operador lia isso como "o filtro de serviço não
         * funciona" (relato de 13/10/2026).
         *
         * Isto NÃO move o filtro para o servidor: `applyAdvancedSearchFilters`
         * continua decidindo o que a tela mostra. Muda quais 100 finalizados
         * vêm -- de "os 100 mais recentes" para "os 100 mais recentes que
         * casam". Ver `utils/condicoesDaBuscaAvancada`, que só traduz o campo
         * quando a condição do servidor é igual ou mais ampla.
         */
        if (condicoes && condicoes.length) params.conditions = condicoes;
        http.get('/ticket/paginated', { params })
            .then((res) => {
                const data = (res.data?.data || []).map((t) => normalizeTicketAssigneeForList(t));
                setFinalizedExtra((prev) => {
                    if (reset) return data;
                    const seen = new Set(prev.map((t) => t.id));
                    return [...prev, ...data.filter((t) => !seen.has(t.id))];
                });
                setFinalizedPage(res.data?.current_page || page);
                setFinalizedHasMore((res.data?.current_page || 1) < (res.data?.last_page || 1));
            })
            .catch(() => {})
            .finally(() => { finalizedLoadingRef.current = false; });
    }, []);

    // (Re)carrega a 1ª página quando muda o conjunto de finalizados; zera no kanban/busca.
    useEffect(() => {
        if (serverSearchResults != null || !finalizedKey) {
            setFinalizedExtra([]);
            setFinalizedHasMore(false);
            setFinalizedPage(1);
            return;
        }
        loadFinalizedPage(finalizedKey.split(',').map((s) => Number(s)), 1, true, serverFilterId, condicoesDoServidor);
    }, [finalizedKey, serverSearchResults, loadFinalizedPage, serverFilterId, condicoesDoServidor]);

    // Refinamentos que so existem no navegador: o servidor nao sabe
    // reproduzir esse recorte, entao pedir a ele a lista ordenada devolveria
    // OUTRA lista. Enquanto um deles estiver ligado, o cabecalho fica inerte.
    const refinamentoSoNoNavegador = Boolean(panelFilter || advancedSearchFilters || indicatorShortcut);

    const sortDisabledReason = refinamentoSoNoNavegador
        ? 'A lista esta refinada aqui no navegador (busca avancada, painel ou indicador). Limpe o refinamento para ordenar.'
        : null;

    const handleSortChange = useCallback((chave) => {
        setSort((atual) => proximaOrdenacao(atual, chave));
    }, []);

    const SORTED_PAGE_SIZE = 100;

    const loadSortedPage = useCallback((ordenacao, page, reset, filterId, term) => {
        if (sortedLoadingRef.current || !ordenacao) return;
        sortedLoadingRef.current = true;
        comecouBuscaNoServidor();
        const params = { per_page: SORTED_PAGE_SIZE, page, sort_by: ordenacao.by, sort_dir: ordenacao.dir };
        // As mesmas duas coisas que o servidor ja sabe aplicar na listagem: as
        // condicoes do filtro salvo e a busca por texto.
        if (filterId) params.filter_id = filterId;
        if (term && term.length >= 2) params.search = term;
        http.get('/ticket/paginated', { params })
            .then((res) => {
                const data = (res.data?.data || []).map((t) => normalizeTicketAssigneeForList(t));
                setSortedRows((prev) => {
                    if (reset || prev == null) return data;
                    const seen = new Set(prev.map((t) => t.id));
                    return [...prev, ...data.filter((t) => !seen.has(t.id))];
                });
                setSortedPage(res.data?.current_page || page);
                setSortedHasMore((res.data?.current_page || 1) < (res.data?.last_page || 1));
            })
            .catch(() => {})
            .finally(() => { sortedLoadingRef.current = false; terminouBuscaNoServidor(); });
    }, [comecouBuscaNoServidor, terminouBuscaNoServidor]);

    /**
     * Carrega a lista de "abertos hoje" INTEIRA, do servidor.
     *
     * Os outros quatro cards dos indicadores recortam dentro da lista de
     * ativos, que já está toda em memória. Este não: ele conta o que foi
     * criado hoje, resolvido ou não, e os finalizados chegam de 100 em 100
     * conforme a rolagem. Refinando no navegador, o número da lista dependia
     * de quanto o operador havia rolado -- a origem do "card diz 30, lista
     * mostra 18".
     *
     * `created_today=1` em vez de `created_from`/`created_to` calculados aqui:
     * assim "hoje" sai de `Ticket::scopeCriadosHoje()`, a MESMA expressão que
     * o número do card usa. Com as bordas vindo do navegador, "hoje" passaria
     * a depender do fuso do cliente enquanto o card depende do fuso do
     * servidor.
     *
     * Pagina em laço, e não por rolagem, porque o número do card tem de bater
     * com a lista COMPLETA -- carregar só a primeira página reproduziria o
     * defeito que isto conserta. "Criado hoje" é um conjunto limitado por
     * natureza; o teto existe para um dia anormal não virar laço infinito.
     */
    useEffect(() => {
        if (indicatorShortcut?.sub !== 'openedToday') {
            setLinhasDeHoje(null);
            setTotalDeHoje(null);
            return undefined;
        }

        let cancelado = false;

        // Lambda, e nao `http.get` solto: o axios 0.21 vincula os metodos da
        // instancia (conferido), mas passar o metodo desacoplado deixa a tela
        // dependendo desse detalhe numa eventual atualizacao -- e o teste do
        // util usa um dublê, entao nao acusaria a quebra.
        buscarCriadosHoje((url, config) => http.get(url, config))
            .then(({ linhas, total }) => {
                if (cancelado) return;
                setLinhasDeHoje(linhas.map((t) => normalizeTicketAssigneeForList(t)));
                setTotalDeHoje(total);
            })
            .catch(() => {
                // Lista VAZIA e nao `null`: `null` significa "este card nao
                // esta ativo" e faria a tela cair de volta na lista de ativos
                // em memoria -- que nao e o recorte que o operador pediu, e
                // ele nao teria como saber.
                if (!cancelado) {
                    setLinhasDeHoje([]);
                    setTotalDeHoje(0);
                }
            });

        return () => { cancelado = true; };
    }, [indicatorShortcut]);

    // (Re)carrega a 1a pagina quando a ordenacao, o filtro ou a busca mudam.
    // Sem ordenacao escolhida, zera e devolve a tela ao caminho de sempre.
    useEffect(() => {
        if (viewMode === 'kanban' || !sort || refinamentoSoNoNavegador) {
            setSortedRows(null);
            setSortedHasMore(false);
            setSortedPage(1);
            return;
        }
        // Debounce, como na contagem do rodape: sem ele, digitar na busca
        // dispararia uma pagina por tecla.
        const timer = setTimeout(() => {
            loadSortedPage(sort, 1, true, serverFilterId, (searchValue || '').trim());
        }, 300);
        return () => clearTimeout(timer);
    }, [viewMode, sort, refinamentoSoNoNavegador, serverFilterId, searchValue, loadSortedPage]);

    // Scroll infinito da LISTAGEM (react-virtuoso): ao chegar no fim, carrega mais.
    // Se há busca ativa, pagina os resultados da busca; senão, os finalizados.
    const handleListEndReached = useCallback(() => {
        // O modo ordenado tem a propria paginacao: e a lista inteira, vinda
        // do servidor, e nao a mescla de ativos com finalizados.
        if (sortedRows != null) {
            if (sortedHasMore && !sortedLoadingRef.current) {
                loadSortedPage(sort, sortedPage + 1, false, serverFilterId, (searchValue || '').trim());
            }
            return;
        }
        if (serverSearchResults != null) {
            if (searchMeta.page > 0 && searchMeta.page < searchMeta.lastPage && !searchLoadingRef.current) {
                fetchSearchPage((searchValue || '').trim(), searchMeta.page + 1);
            }
            return;
        }
        if (finalizedHasMore && !finalizedLoadingRef.current && finalizedKey) {
            loadFinalizedPage(finalizedKey.split(',').map((s) => Number(s)), finalizedPage + 1, false, serverFilterId, condicoesDoServidor);
        }
    }, [sortedRows, sortedHasMore, sortedPage, sort, loadSortedPage, serverSearchResults, searchMeta, searchValue, fetchSearchPage, finalizedHasMore, finalizedKey, finalizedPage, loadFinalizedPage, serverFilterId]);

    useEffect(() => {
        // Quando há busca server-side ativa, ela é a base (inclui fechados);
        // caso contrário, usa os tickets ativos carregados em memória.
        // No modo ordenado a lista JA vem inteira e ordenada do servidor:
        // mesclar os ativos de memoria aqui desfaria a ordem.
        // "Abertos hoje" tem precedência sobre todas as outras fontes: a lista
        // dele vem INTEIRA do servidor (criados hoje, qualquer status), e
        // mesclar os ativos de memória aqui traria de volta chamados que não
        // foram criados hoje.
        let baseTickets = linhasDeHoje != null
            ? linhasDeHoje
            : (sortedRows != null
                ? sortedRows
                : (serverSearchResults != null ? serverSearchResults : (props.tickets.tickets || [])));
        // Mescla os finalizados buscados sob demanda (sem duplicar por id).
        if (linhasDeHoje == null && sortedRows == null && finalizedExtra.length > 0) {
            const seen = new Set(baseTickets.map((t) => t.id));
            baseTickets = [...baseTickets, ...finalizedExtra.filter((t) => !seen.has(t.id))];
        }
        let filteredTickets = baseTickets;

        // Filtro do Painel de tickets: restringe aos IDs da seção clicada.
        if (panelFilter && Array.isArray(panelFilter.ids)) {
            const idSet = new Set(panelFilter.ids.map((n) => Number(n)));
            filteredTickets = filteredTickets.filter((t) => idSet.has(Number(t.id)));
        }

        if (indicatorShortcut) {
            filteredTickets = applyIndicatorShortcutFilter(
                filteredTickets,
                indicatorShortcut,
                props.currentUser,
                { emAtendimentoStatusId, abertoStatusId, pendenteStatusId }
            );
        }

        // Aplicar busca avançada primeiro
        if (advancedSearchFilters) {
            filteredTickets = applyAdvancedSearchFilters(filteredTickets, advancedSearchFilters, props.currentUser, idsDeStatusFinalizados, paiPorIdDoServico);
        }

        // Aplicar busca de texto simples (apenas em memória; com busca server-side
        // o backend já fez a filtragem por texto).
        // No modo ordenado o servidor ja filtrou por texto. Refiltrar aqui
        // descartaria linha que ele casou por campo que esta funcao nao le.
        if (searchValue && serverSearchResults == null && sortedRows == null) {
            filteredTickets = filteredTickets.filter(ticket =>
                mapTicketToSearchString(ticket).toLowerCase().includes(searchValue.toLowerCase())
            );
        }

        // Aplicar filtros salvos se houver
        if (props.selectedFilter && typeof props.selectedFilter === 'object') {
            if (props.selectedFilter.conditions && props.selectedFilter.conditions.length > 0) {
                filteredTickets = applyFilterConditions(filteredTickets, props.selectedFilter.conditions);
            }
        }

        setRows(filteredTickets);
    }, [
        props.tickets,
        props.currentUser,
        serverSearchResults,
        indicatorShortcut,
        emAtendimentoStatusId,
        abertoStatusId,
        pendenteStatusId,
        searchValue,
        advancedSearchFilters,
        props.selectedFilter,
        applyFilterConditions,
        finalizedExtra,
        panelFilter,
        sortedRows,
        // Sem isto a lista nao se redesenha quando a busca de "abertos hoje"
        // termina: `setLinhasDeHoje` resolve depois deste efeito ja ter
        // rodado, e a tela ficaria com as linhas antigas. Foi o aviso de
        // dependencia do eslint que acusou.
        linhasDeHoje,
        // Mesma historia, outros dados: os status cadastrados e a arvore de
        // servicos chegam por requisicao. Sem eles, a busca avancada fica
        // congelada no primeiro render -- "Nao concluido" com a lista de
        // finais vazia deixa TUDO passar, e o servico com o mapa vazio casa
        // so igualdade exata, divergindo do servidor. Sem erro nenhum.
        idsDeStatusFinalizados,
        paiPorIdDoServico,
    ]);

    // Persiste busca/busca avancada/atalho de indicadores (debounce curto).
    // Ficam guardados ate o operador mudar ou remover -- inclusive depois de
    // fechar o navegador (ponto 12 da Gisele, 27/10/2026).
    useEffect(() => {
        const t = setTimeout(() => {
            gravarRefinamentosDaListagem({ searchValue, advancedSearchFilters, indicatorShortcut });
        }, 150);
        return () => clearTimeout(t);
    }, [searchValue, advancedSearchFilters, indicatorShortcut]);

    // Persiste a posicao de scroll do wrapper da listagem/kanban
    useEffect(() => {
        const el = tableWrapperRef.current;
        if (!el) return undefined;
        let t;
        const onScroll = () => {
            clearTimeout(t);
            t = setTimeout(() => gravarRefinamentosDaListagem({ scrollTop: el.scrollTop }), 150);
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            clearTimeout(t);
            el.removeEventListener('scroll', onScroll);
        };
    }, []);

    // Restaura o scroll uma vez, apos as linhas estabilizarem. Tenta repetidas
    // vezes porque o conteudo (kanban/lista) ganha altura de forma progressiva.
    useEffect(() => {
        if (scrollRestoredRef.current) return;
        const savedTop = persistedSessionRef.current.scrollTop;
        if (!savedTop) {
            scrollRestoredRef.current = true;
            return;
        }
        if (rows.length === 0) return;
        let attempts = 0;
        const tryRestore = () => {
            const el = tableWrapperRef.current;
            if (!el) return;
            el.scrollTop = savedTop;
            attempts += 1;
            if (el.scrollTop < savedTop - 1 && attempts < 12) {
                setTimeout(tryRestore, 60);
            } else {
                scrollRestoredRef.current = true;
            }
        };
        requestAnimationFrame(tryRestore);
    }, [rows]);

    const kanbanColumnsFromFilter = useMemo(() => {
        const kc = props.selectedFilter?.settings?.kanban_columns;
        if (!Array.isArray(kc) || kc.length === 0) return [];
        // A coluna de arquivo/lixeira só existe na configuração; não é exibida no quadro.
        return parseKanbanColumnsFromFilter(kc, ticketStatuses ?? []).filter((col) => !isArchiveColumn(col));
    }, [props.selectedFilter?.settings?.kanban_columns, ticketStatuses]);

    const ticketsByColumn = useMemo(() => {
        const byCol = {};
        kanbanColumnsFromFilter.forEach((col) => { byCol[col.id] = []; });
        // A regra mora em `utils/cabeNaColuna`, com teste: o aviso de
        // "resultados fora das colunas" precisa fazer a MESMA pergunta que o
        // quadro, senão ele conta errado o que escondeu.
        const match = casaColuna;
        // Base = tickets ativos (rows) + histórico carregado por responsável
        // (groupExtra), sem duplicar. O agrupamento por coluna distribui todos.
        let base = [...(rows || [])];
        const seen = new Set(base.map((t) => t.id));
        // groupExtra é aninhado por responsável -> coluna: { [assignee]: { [colId]: {items} } }.
        Object.values(groupExtra).forEach((byCol) => {
            Object.values(byCol || {}).forEach((cell) => {
                (cell?.items || []).forEach((t) => {
                    if (!seen.has(t.id)) {
                        seen.add(t.id);
                        base.push(t);
                    }
                });
            });
        });
        // O groupExtra é carregado por status_id (todas as colunas) sem passar
        // pelos filtros; reaplica aqui para que o kanban respeite tanto o filtro
        // salvo (condições) quanto a busca avançada aplicada pelo modal.
        if (advancedSearchFilters) {
            base = applyAdvancedSearchFilters(base, advancedSearchFilters, props.currentUser, idsDeStatusFinalizados, paiPorIdDoServico);
        }
        const conds = props.selectedFilter?.conditions;
        if (Array.isArray(conds) && conds.length > 0) {
            base = applyFilterConditions(base, conds);
        }
        base.forEach((ticket) => {
            // Só entram no quadro os tickets que casam com alguma coluna do filtro.
            // (Antes, os não-correspondentes eram despejados na primeira coluna, o
            // que misturava tickets ativos num kanban filtrado só por finalizados.)
            kanbanColumnsFromFilter.forEach((col) => {
                if (match(ticket, col)) {
                    byCol[col.id].push(ticket);
                }
            });
        });

        // A ordenação entra AQUI, depois da junção, e é por isso que ela
        // acerta as duas fontes de uma vez: `base` é `rows` (memória) seguido
        // do `groupExtra` (páginas do servidor), nessa ordem de chegada. Sem
        // este passo, a coluna sai na ordem em que os cartões FORAM
        // CARREGADOS -- os ativos primeiro, o histórico depois -- o que já
        // era uma ordem sem significado antes de existir escolha.
        //
        // `ordenarChamados` imita o `ORDER BY` do MySQL (nulos e desempate
        // por id), porque quem pagina é o servidor: pedir "os dez próximos
        // por prioridade" só faz sentido se o navegador concordar sobre quais
        // são os dez primeiros.
        Object.keys(byCol).forEach((colId) => {
            byCol[colId] = ordenarChamados(byCol[colId], kanbanSort.campo, kanbanSort.direcao);
        });

        return byCol;
    }, [rows, kanbanColumnsFromFilter, groupExtra, props.selectedFilter, applyFilterConditions, advancedSearchFilters, idsDeStatusFinalizados, paiPorIdDoServico, props.currentUser, kanbanSort]);

    /*
     * Os resultados da busca que o QUADRO não tem onde desenhar.
     *
     * O quadro só mostra o cartão cujo status casa alguma coluna do Kanban.
     * Buscando o 267230 dentro do Kanban Comercial, o servidor encontra, o
     * chamado chega à tela e some -- sem erro, sem lista vazia, só um quadro
     * sem aquele cartão. Quem está olhando lê isso como "o sistema não acha o
     * chamado" (Gisele, 27/10/2026).
     *
     * Só vale durante uma busca: fora dela, "chamado que não cabe em nenhuma
     * coluna" é o funcionamento normal de um Kanban recortado, e avisar seria
     * ruído permanente.
     *
     * Calculado sobre `rows` e não sobre a base do quadro de propósito: com
     * busca ativa o `groupExtra` é zerado (o efeito logo abaixo depende de
     * `serverSearchResults`), então as duas são a mesma coisa aqui.
     */
    /*
     * Há alguma lista a caminho?
     *
     * `props.tickets.loading` e o contador cobrem as três esperas que o
     * operador sente: abrir a tela (a lista de ativos), ordenar e buscar no
     * servidor. A paginação por rolagem fica de fora de propósito -- ali a
     * tela já tem conteúdo e o que chega é um acréscimo no fim.
     */
    const carregando = Boolean(props.tickets?.loading) || buscasNoServidor > 0;

    const buscaAtiva = (searchValue || '').trim().length > 0;

    const resultadosForaDasColunas = useMemo(
        () => (buscaAtiva ? foraDasColunas(rows, kanbanColumnsFromFilter) : []),
        [buscaAtiva, rows, kanbanColumnsFromFilter]
    );

    // Reseta o histórico carregado ao trocar de filtro ou buscar.
    //
    // `kanbanSort` entra na lista, e isto NÃO é zelo: as páginas já baixadas
    // foram as "dez primeiras" da ordem ANTERIOR. Mantê-las ao trocar a
    // ordenação deixa no quadro um recorte que não é o começo de nada -- os
    // dez mais recentes misturados com os dez mais prioritários, e o
    // "carregar mais" seguindo a partir da página 2 da ordem nova. O
    // resultado é cartão repetido e cartão faltando, sem erro nenhum.
    useEffect(() => {
        setGroupExtra({});
        loadingGroupsRef.current = {};
    }, [props.selectedFilter, serverSearchResults, kanbanSort]);

    const columnTotal = useCallback((col) => {
        if (!kanbanCounts || !kanbanCounts.by_status) return null;
        const statusIds = [...new Set((col.items || []).map((it) => String(it.status_id)))];
        return statusIds.reduce((sum, sid) => sum + (Number(kanbanCounts.by_status[sid]) || 0), 0);
    }, [kanbanCounts]);

    // Todos os status presentes nas colunas do kanban (filtro da carga).
    const allColumnStatusIds = useMemo(() => {
        const set = new Set();
        kanbanColumnsFromFilter.forEach((col) => {
            (col.items || []).forEach((it) => { if (it.status_id != null) set.add(it.status_id); });
        });
        return [...set];
    }, [kanbanColumnsFromFilter]);

    // status_id que a CONDIÇÃO do filtro (ou busca avançada) restringe. Se houver,
    // o kanban só deve considerar esses status — ex.: filtro "Resolvidos" com
    // condição status_id=5 faz só a coluna Resolvido ter tickets (as outras zeram).
    const conditionStatusIds = useMemo(() => {
        const ids = new Set();
        (props.selectedFilter?.conditions || []).forEach((c) => {
            const field = c.field_name || c.field;
            if (field !== 'status_id') return;
            let vals = c.value;
            if (typeof vals === 'string') {
                try { vals = JSON.parse(vals); } catch { vals = String(vals).split(',').map((s) => s.trim()); }
            }
            (Array.isArray(vals) ? vals : [vals]).forEach((v) => {
                const n = Number(v);
                if (!Number.isNaN(n)) ids.add(n);
            });
        });
        const advStatus = advancedSearchFilters?.status;
        if (advStatus !== '' && advStatus != null) ids.add(Number(advStatus));
        return [...ids];
    }, [props.selectedFilter, advancedSearchFilters]);

    // Status efetivos do kanban: colunas ∩ condição de status (quando houver).
    const effectiveColumnStatusIds = useMemo(() => {
        if (conditionStatusIds.length === 0) return allColumnStatusIds;
        const allow = new Set(conditionStatusIds.map(Number));
        return allColumnStatusIds.filter((id) => allow.has(Number(id)));
    }, [allColumnStatusIds, conditionStatusIds]);

    // Contagem real por responsável (grupos do kanban), para montar TODOS os
    // grupos com o total certo sem carregar os tickets. Só no kanban e sem busca.
    // Usa os status EFETIVOS (respeita a condição do filtro).
    useEffect(() => {
        if (viewMode !== 'kanban' || serverSearchResults != null || effectiveColumnStatusIds.length === 0) {
            setAssigneeCounts(null);
            return undefined;
        }
        let cancelled = false;
        // filter_id => o backend aplica TODAS as condições do filtro (data, grupo...)
        // no agregado. Sem isso, o kanban contava tickets fora do período e mostrava
        // responsáveis que só tinham tickets fora do filtro (contagem errada).
        const params = { status_id: effectiveColumnStatusIds };
        // incluir_sem_responsavel => o agregado conta também os chamados SEM
        // responsável quando o filtro restringe por grupo de atendimento. O
        // grupo vem do responsável, então sem responsável não há grupo e o
        // servidor os descartava -- a coluna "Não atribuído" ficava sem nada
        // para mostrar, e com ela os chamados do operador inativado (ponto 1
        // da Gisele). Os outros grupos não mudam: chamado sem responsável só
        // cai no balde "unassigned".
        if (serverFilterId) {
            params.filter_id = serverFilterId;
            params.incluir_sem_responsavel = 1;
        }
        http.get('/ticket/assignee-counts', { params })
            .then((res) => { if (!cancelled) setAssigneeCounts(res.data?.groups || []); })
            .catch(() => { if (!cancelled) setAssigneeCounts(null); });
        return () => { cancelled = true; };
    }, [viewMode, serverSearchResults, effectiveColumnStatusIds, serverFilterId]);

    // Contagens por status para o cabeçalho do topo. Respeita os status efetivos
    // (condição do filtro), pra o topo não mostrar coluna que a condição exclui.
    useEffect(() => {
        if (viewMode !== 'kanban' || serverSearchResults != null) {
            return undefined;
        }
        let cancelled = false;
        const params = effectiveColumnStatusIds.length > 0 ? { status_id: effectiveColumnStatusIds } : {};
        if (serverFilterId) params.filter_id = serverFilterId;
        http.get('/ticket/counts', { params })
            .then((res) => { if (!cancelled) setKanbanCounts(res.data); })
            .catch(() => {});
        return () => { cancelled = true; };
    }, [viewMode, serverSearchResults, effectiveColumnStatusIds, serverFilterId]);

    // Total REAL da categoria/filtro para o header da LISTAGEM (item 9): conta no
    // servidor (todos os status, inclui finalizados), respeitando o filtro salvo e a
    // busca por texto. Refinamentos só-de-front (painel por ids, atalho de
    // indicador) não são representáveis no servidor -> cai pro nº carregado.
    //
    // A BUSCA AVANÇADA deixou de cair aqui quando todos os campos preenchidos
    // são traduzíveis: `/ticket/counts` passa pelo mesmo `applyTicketFilters`,
    // então contá-la é de graça. Com um campo que ficou no navegador, não: a
    // consulta do servidor é mais ampla de propósito, e o número dele contaria
    // chamados que a tela vai descartar. Ver `totalVemDoServidor`.
    const totalDaBuscaVemDoServidor = useMemo(
        () => totalVemDoServidor(advancedSearchFilters),
        [advancedSearchFilters]
    );

    useEffect(() => {
        const buscaAvancadaImpede = Boolean(advancedSearchFilters) && !totalDaBuscaVemDoServidor;

        if (viewMode === 'kanban' || panelFilter || buscaAvancadaImpede || indicatorShortcut) {
            setListTotal(null);
            return undefined;
        }
        let cancelled = false;
        const params = {};
        if (serverFilterId) params.filter_id = serverFilterId;
        if (condicoesDoServidor.length) params.conditions = condicoesDoServidor;
        const term = (searchValue || '').trim();
        if (term.length >= 2) params.search = term;
        // Debounce (evita uma contagem por tecla enquanto digita a busca).
        const timer = setTimeout(() => {
            http.get('/ticket/counts', { params })
                .then((res) => { if (!cancelled) setListTotal(typeof res.data?.total === 'number' ? res.data.total : null); })
                .catch(() => { if (!cancelled) setListTotal(null); });
        }, 300);
        return () => { cancelled = true; clearTimeout(timer); };
    }, [viewMode, panelFilter, advancedSearchFilters, totalDaBuscaVemDoServidor, condicoesDoServidor, indicatorShortcut, serverFilterId, searchValue]);

    // Mapa responsável -> agregado (com by_status), p/ saber quais colunas do
    // responsável têm tickets e o total de cada uma.
    // Grupos de atendimento que a CONDIÇÃO do filtro restringe (grupo do responsável).
    const conditionServiceGroupIds = useMemo(() => {
        const ids = new Set();
        (props.selectedFilter?.conditions || []).forEach((c) => {
            const field = c.field_name || c.field;
            if (field !== 'service_group_id') return;
            if (c.operator !== 'equals' && c.operator !== 'in') return;
            let vals = c.value;
            if (typeof vals === 'string') {
                try { vals = JSON.parse(vals); } catch { vals = String(vals).split(',').map((s) => s.trim()); }
            }
            (Array.isArray(vals) ? vals : [vals]).forEach((v) => {
                const n = Number(v);
                if (!Number.isNaN(n)) ids.add(n);
            });
        });
        return [...ids];
    }, [props.selectedFilter]);

    const userServiceGroupById = useMemo(() => {
        const map = {};
        (props.users || []).forEach((u) => { map[String(u.id)] = u.service_group_id ?? u.service_group?.id ?? null; });
        return map;
    }, [props.users]);

    // Grupos do agregado visíveis: se o filtro restringe por grupo de atendimento,
    // mostra só os responsáveis daquele(s) grupo(s) — senão o kanban listava
    // todos, e os de outro grupo ficavam vazios. "Não atribuído" fica FORA do
    // recorte (ponto 1 da Gisele): ver `utils/responsaveisVisiveisNoKanban`.
    const visibleAssigneeCounts = useMemo(
        () => responsaveisVisiveisNoKanban(assigneeCounts, conditionServiceGroupIds, userServiceGroupById),
        [assigneeCounts, conditionServiceGroupIds, userServiceGroupById]
    );

    /**
     * O mesmo recorte, por chave, para o kanban aplicar nos DOIS caminhos de
     * montar grupo.
     *
     * Durante a BUSCA o agregado é desligado (`assigneeCounts = null`) e o
     * kanban agrupa os chamados carregados -- caminho que não passava por
     * `visibleAssigneeCounts`. Era por isso que a busca mostrava operador de
     * outro departamento.
     */
    const responsavelVisivelNoKanbanAtual = useCallback(
        (chave) => responsavelVisivelNoKanban(chave, conditionServiceGroupIds, userServiceGroupById),
        [conditionServiceGroupIds, userServiceGroupById]
    );

    const assigneeCountsByKey = useMemo(() => {
        const map = {};
        (visibleAssigneeCounts || []).forEach((g) => { map[String(g.key)] = g; });
        return map;
    }, [visibleAssigneeCounts]);

    // Total de UM responsável numa coluna (soma o by_status dos status da coluna).
    // A conta mora em `utils/totalDaColunaDoKanban`, com teste: ela soma por
    // status E SUBSTATUS, que e como a coluna e definida. Somando so por status,
    // o mesmo chamado entrava em duas colunas e a segunda prometia um cartao que
    // nao tem (medido em producao em 23/10, faixa Comercial: "0/1").
    const assigneeColumnTotal = useCallback(
        (assigneeKey, col) => totalDaColunaDoKanban(assigneeCountsByKey[String(assigneeKey)], col),
        [assigneeCountsByKey]
    );

    // Carrega uma página (10) de UMA coluna de UM responsável, isolando os status
    // daquela coluna — assim cada coluna pagina sozinha (sem divisão aleatória).
    const loadAssigneeColumnPage = useCallback((assigneeKey, col, page) => {
        const cellKey = `${assigneeKey}::${col.id}`;
        if (loadingGroupsRef.current[cellKey]) return;
        const statusIds = (col.items || []).map((it) => it.status_id).filter((v) => v != null);
        if (statusIds.length === 0) return;
        loadingGroupsRef.current[cellKey] = true;
        // filter_id: aplica as condições do filtro (data, etc.) também ao carregar a
        // coluna do responsável — senão traria tickets fora do período do filtro.
        // A ordenação escolhida vai para o servidor, e não só para a tela: ele
        // é quem pagina de dez em dez. Se ele ordenasse por `updated_at` fixo
        // e a tela reordenasse por prioridade, "carregar mais" traria os dez
        // próximos POR DATA -- e a coluna ficaria ordenada por prioridade só
        // dentro do que ja chegou, nunca a de verdade.
        const params = {
            assigned_to: assigneeKey,
            status_id: statusIds,
            per_page: 10,
            page,
            sort_by: kanbanSort.campo,
            sort_dir: kanbanSort.direcao,
        };
        if (serverFilterId) {
            params.filter_id = serverFilterId;
            /*
             * Para TODO grupo sem responsável -- o balde genérico e os de
             * departamento --, e pelo mesmo motivo do agregado: senão o
             * grupo aparecia com a contagem certa no cabeçalho e vazio por
             * dentro, porque a condição de grupo de atendimento do filtro
             * descarta chamado sem responsável.
             *
             * A comparação era com a string `unassigned` exata. Os grupos de
             * departamento têm chave `unassigned:<id>`, então ficavam de fora
             * e era exatamente neles que o sintoma aparecia (ponto 25).
             */
            if (ehGrupoSemResponsavel(assigneeKey)) params.incluir_sem_responsavel = 1;
        }
        http.get('/ticket/paginated', { params })
            .then((res) => {
                const data = (res.data?.data || []).map((t) => normalizeTicketAssigneeForList(t));
                setGroupExtra((prev) => {
                    const byCol = prev[assigneeKey] || {};
                    const existing = byCol[col.id]?.items || [];
                    const ids = new Set(existing.map((t) => t.id));
                    return {
                        ...prev,
                        [assigneeKey]: {
                            ...byCol,
                            [col.id]: {
                                items: [...existing, ...data.filter((t) => !ids.has(t.id))],
                                page: res.data?.current_page || page,
                                hasMore: (res.data?.current_page || 1) < (res.data?.last_page || 1),
                            },
                        },
                    };
                });
            })
            .catch(() => {})
            .finally(() => { loadingGroupsRef.current[cellKey] = false; });
    }, [serverFilterId, kanbanSort]);

    // Botão "Carregar mais" de uma coluna: pega a próxima página daquela célula.
    const handleLoadColumnMore = useCallback((assigneeKey, col) => {
        const cell = groupExtra[assigneeKey]?.[col.id];
        loadAssigneeColumnPage(assigneeKey, col, (cell?.page || 1) + 1);
    }, [groupExtra, loadAssigneeColumnPage]);

    // Recebe do kanban quais responsáveis estão expandidos.
    const handleExpandedAssigneesChange = useCallback((keys) => {
        setExpandedAssigneeKeys(keys);
    }, []);

    // Ao abrir um grupo, carrega a 1ª página de cada coluna NÃO-VAZIA daquele
    // responsável (10 por coluna). Colunas vazias pra ele nem são chamadas.
    useEffect(() => {
        if (viewMode !== 'kanban' || serverSearchResults != null) return;
        expandedAssigneeKeys.forEach((key) => {
            kanbanColumnsFromFilter.forEach((col) => {
                const already = groupExtra[key]?.[col.id];
                if (!already && assigneeColumnTotal(key, col) > 0 && !loadingGroupsRef.current[`${key}::${col.id}`]) {
                    loadAssigneeColumnPage(key, col, 1);
                }
            });
        });
    }, [expandedAssigneeKeys, viewMode, serverSearchResults, groupExtra, kanbanColumnsFromFilter, assigneeColumnTotal, loadAssigneeColumnPage]);

    // Scroll infinito: ao chegar perto do fim, carrega a próxima página de cada
    // coluna (de cada responsável aberto) que ainda tem histórico.
    useEffect(() => {
        if (viewMode !== 'kanban' || serverSearchResults != null) return undefined;
        const el = tableWrapperRef.current;
        if (!el) return undefined;
        const onScroll = () => {
            if (el.scrollTop + el.clientHeight < el.scrollHeight - 350) return;
            expandedAssigneeKeys.forEach((key) => {
                kanbanColumnsFromFilter.forEach((col) => {
                    const cell = groupExtra[key]?.[col.id];
                    if (cell && cell.hasMore && !loadingGroupsRef.current[`${key}::${col.id}`]) {
                        loadAssigneeColumnPage(key, col, (cell.page || 1) + 1);
                    }
                });
            });
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, [viewMode, serverSearchResults, expandedAssigneeKeys, groupExtra, kanbanColumnsFromFilter, loadAssigneeColumnPage]);

    const kanbanCardFields = useMemo(() => {
        const filter = props.selectedFilter;
        if (!filter || typeof filter !== 'object') return [];
        const out = [];
        const standardFields = filter.settings?.standard_fields || [];
        const standardGetters = {
            id: (t) => t.id,
            title: (t) => t.title || '-',
            status: (t) => t.ticket_status?.name || mapStatus(t.status),
            // A API publica esse campo como 'status_id'; o alias evita que marcar
            // "Status" no filtro seja ignorado em silencio no card do kanban.
            status_id: (t) => t.ticket_status?.name || mapStatus(t.status),
            priority: (t) => mapPriority(t.priority),
            assigned_to: (t) => getTicketAssigneeDisplayName(t),
            service_group_id: (t) =>
                t.assigned_to?.service_group?.description ||
                (getTicketAssigneeServiceGroupId(t) != null ? `#${getTicketAssigneeServiceGroupId(t)}` : '—'),
            created_by: (t) => t.created_by?.name || 'Sistema',
            client: (t) => formatTicketClientDisplay(t) || '',
            category: (t) => t.category || '',
            product: (t) => getTicketProduct(t) || '',
            service: (t) => getTicketServiceLabel(t) || '',
            representative: (t) => getTicketRepresentative(t) || '',
            contact: (t) => t.contact || '',
            channel: (t) => t.channel || '',
            is_internal: (t) => (t.is_internal ? 'Interno' : 'Público'),
            created_at: (t) => formatTicketDateTime(t.created_at),
            resolved_at: (t) => formatTicketDateTime(t.resolved_at),
            updated_at: (t) => formatTicketDateTime(t.updated_at)
        };
        const standardLabels = {
            id: 'Protocolo', title: 'Assunto', status: 'Status', status_id: 'Status', priority: 'Prioridade',
            assigned_to: 'Responsável', service_group_id: 'Grupo (resp.)', created_by: 'Criado por', client: 'Cliente', category: 'Categoria',
            product: 'Produto', service: 'Serviço', representative: 'Representante',
            contact: 'Contato', channel: 'Canal', is_internal: 'Tipo',
            created_at: 'Data de abertura', resolved_at: 'Data de resolução', updated_at: 'Data de Atualização'
        };
        standardFields.forEach((f) => {
            if (f.visible && standardGetters[f.name] && standardLabels[f.name]) {
                out.push({ label: standardLabels[f.name], getValue: standardGetters[f.name] });
            }
        });
        const customFields = Array.isArray(filter.fields) ? filter.fields : [];
        customFields.forEach((field) => {
            if (field.pivot && field.pivot.visible && field.name) {
                out.push({
                    label: field.name,
                    getValue: (t) => {
                        const all = t.fields || [];
                        const f = all.find((ff) => ff.field_id === field.id);
                        return f != null ? f.value : '';
                    }
                });
            }
        });
        const clientIdx = out.findIndex((item) => item.label === 'Cliente');
        if (clientIdx > 0) {
            const [clientItem] = out.splice(clientIdx, 1);
            out.unshift(clientItem);
        }
        return out;
    }, [props.selectedFilter]);

    const defaultListColumns = useMemo(() => {
        const isMd = isDefaultListMdDown;
        const isSm = isDefaultListSmDown;
        const fs = isSm ? '0.68rem' : '0.72rem';
        const head = {
            title: 'Assunto',
            status: isSm ? 'Sit.' : isMd ? 'Status' : 'STATUS',
            priority: isSm ? 'Prior.' : isMd ? 'Prioridade' : 'PRIORIDADE',
            assigned: isSm ? 'Resp.' : isMd ? 'Responsável' : 'RESPONSÁVEL',
            client: isMd ? 'Cliente' : 'CLIENTE',
            attendance: isSm ? 'Tempo' : 'Tempo atend.',
        };
        const mw = {
            id: isSm ? 38 : isMd ? 44 : 50,
            title: isSm ? 92 : isMd ? 108 : 120,
            // Mais largura desde 19/10: a coluna passou a carregar a
            // justificativa embaixo do status, e o nome dela é texto livre.
            status: isSm ? 84 : isMd ? 96 : 108,
            priority: isSm ? 58 : isMd ? 66 : 72,
            assigned: isSm ? 88 : isMd ? 94 : 100,
            client: isSm ? 88 : isMd ? 94 : 100,
            attendance: isSm ? 64 : isMd ? 72 : 80,
        };
        const fx = {
            id: isSm ? 0.24 : isMd ? 0.32 : 0.4,
            title: isSm ? 1.35 : 1.65,
            // Mais flex desde 19/10, pelo mesmo motivo do minWidth: a coluna
            // carrega duas informacoes agora, e a justificativa e texto livre.
            status: isSm ? 0.85 : 1.1,
            priority: isSm ? 0.55 : 0.65,
            assigned: isSm ? 0.95 : 1.05,
            client: isSm ? 0.95 : 1.05,
            attendance: isSm ? 0.62 : 0.72,
        };

        return [
            {
                field: 'id', headerName: '', flex: fx.id, minWidth: mw.id,
                renderCell: (params) => (
                    <Tooltip title={params.row.number} arrow placement='bottom'>
                        <Typography variant="body2" sx={{ fontSize: fs, lineHeight: 1.2, color: theme.palette.text.primary, textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}>
                            {formatProtocol(params.row.number)}
                        </Typography>
                    </Tooltip>
                )
            },
            {
                field: 'title', headerName: head.title, flex: fx.title, minWidth: mw.title,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.1, py: 0, minWidth: 0 }}>
                        {/*
                          * Mesmas duas regras da outra definição de colunas
                          * (pontos 23 e 28), pelo MESMO util.
                          *
                          * São dois conjuntos de colunas nesta página: um para
                          * o filtro que define as suas, e este, o padrão. Eu
                          * corrigi só o primeiro e validei em produção achando
                          * que estava feito -- a listagem continuou com
                          * "Público" em toda linha, porque quem estava na tela
                          * era este. Daí o util: uma terceira cópia nasce sem
                          * ninguém perceber, e as três divergem em silêncio.
                          */}
                        <Tooltip title={params.row.title} arrow placement='bottom'>
                            <Typography variant="body2" fontWeight={600} sx={{ ...estiloDeCelula(fs), color: theme.palette.text.primary }}>
                                {params.row.title || '-'}
                            </Typography>
                        </Tooltip>
                        {marcaDeTipo(params.row) && (
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isSm ? '0.6rem' : '0.65rem', lineHeight: 1.1 }}>
                                {marcaDeTipo(params.row)}
                            </Typography>
                        )}
                    </Box>
                )
            },
            {
                field: 'status', headerName: head.status, flex: fx.status, minWidth: mw.status,
                renderCell: (params) => {
                    const statusLabel = params.row.ticket_status?.name || mapStatus(params.row.status);
                    const colors = TICKET_LIST_STATUS_CHIP_COLORS[statusLabel] || TICKET_LIST_STATUS_CHIP_COLORS.Pendente;
                    /*
                     * A JUSTIFICATIVA embaixo do status (Gisele, 19/10/2026):
                     * "aumentar o espaço para visualizar melhor".
                     *
                     * Ela já vinha no payload da listagem (`ticketSubstatus` é
                     * eager-loaded desde sempre) e a tela simplesmente não a
                     * desenhava: para saber por que um chamado está Pendente,
                     * o operador tinha de abrir o chamado.
                     *
                     * Cabe sem esticar a linha: a célula do assunto já tem
                     * duas linhas (título + Interno/Público), e a do status
                     * usava só uma -- a segunda estava ali, vazia.
                     */
                    const justificativa = params.row.ticket_substatus?.name;
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.15, minWidth: 0, maxWidth: '100%' }}>
                            <Chip
                                size="small"
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                                        <Box sx={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: colors.dot, flexShrink: 0 }} />
                                        <Box component="span" sx={{ fontSize: isSm ? '0.62rem' : '0.68rem', lineHeight: 1.15, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {statusLabel}
                                        </Box>
                                    </Box>
                                }
                                sx={{
                                    height: 22,
                                    maxWidth: '100%',
                                    backgroundColor: colors.bg,
                                    color: colors.dot,
                                    fontWeight: 500,
                                    '& .MuiChip-label': { px: 0.75, py: 0 },
                                }}
                            />
                            {justificativa && (
                                // O título completo no `title`: a coluna é
                                // estreita e o nome da justificativa é texto
                                // livre, digitado pelo administrador.
                                <Typography
                                    variant="caption"
                                    title={justificativa}
                                    sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: isSm ? '0.6rem' : '0.65rem',
                                        lineHeight: 1.1,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {justificativa}
                                </Typography>
                            )}
                        </Box>
                    );
                }
            },
            {
                field: 'priority', headerName: head.priority, flex: fx.priority, minWidth: mw.priority,
                renderCell: (params) => {
                    const p = mapPriority(params.row.priority);
                    return (
                        <Typography variant="body2" sx={{ fontSize: fs, lineHeight: 1.2, color: TICKET_LIST_PRIORITY_TEXT_COLORS[p] || theme.palette.text.secondary }}>
                            {p}
                        </Typography>
                    );
                }
            },
            {
                field: 'assigned_to', headerName: head.assigned, flex: fx.assigned, minWidth: mw.assigned,
                renderCell: (params) => {
                    const name = getTicketAssigneeDisplayName(params.row, representantes);
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                            <Avatar sx={{ width: isSm ? 20 : 22, height: isSm ? 20 : 22, fontSize: isSm ? '0.6rem' : '0.65rem', bgcolor: theme.palette.primary.main, flexShrink: 0 }}>
                                {getInitials(name)}
                            </Avatar>
                            <Tooltip title={name} arrow placement='bottom'>
                                <Typography variant="body2" fontWeight={500} sx={{ ...estiloDeCelula(fs), color: theme.palette.text.primary }}>
                                    {name}
                                </Typography>
                            </Tooltip>
                        </Box>
                    );
                }
            },
            {
                field: 'client', headerName: head.client, flex: fx.client, minWidth: mw.client,
                renderCell: (params) => {
                    const text = formatTicketClientDisplay(params.row) || 'Não informado';
                    return (
                        <Tooltip title={text} arrow placement='bottom'>
                            <Typography variant="body2" sx={{ ...estiloDeCelula(fs), color: theme.palette.text.secondary }}>
                                {text}
                            </Typography>
                        </Tooltip>
                    );
                }
            },
            {
                field: 'attendance_total_seconds',
                headerName: head.attendance,
                flex: fx.attendance,
                minWidth: mw.attendance,
                sortable: true,
                renderCell: (params) => {
                    const total = Number(params.row.attendance_total_seconds) || 0;
                    const isActive = Boolean(params.row.attendance_has_active);
                    const activeName = params.row.attendance_active_user_name;
                    const label = total > 0 ? formatAttendanceDuration(total) : '—';
                    const tip = isActive
                        ? `Em atendimento agora${activeName ? ` (${activeName})` : ''}${total > 0 ? ` · Total: ${label}` : ''}`
                        : total > 0
                            ? `Tempo registrado no ticket: ${label}`
                            : 'Sem tempo de atendimento registrado';
                    return (
                        <Tooltip title={tip} arrow placement="bottom">
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, minWidth: 0 }}>
                                {isActive && (
                                    <Box
                                        sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            bgcolor: 'success.main',
                                            flexShrink: 0,
                                        }}
                                    />
                                )}
                                <TimerOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ fontSize: fs, lineHeight: 1.2, fontVariantNumeric: 'tabular-nums' }}>
                                    {label}
                                </Typography>
                            </Box>
                        </Tooltip>
                    );
                },
            },
            buildListActionsColumn(),
        ];
    }, [
        representantes,
        theme.palette.text.primary,
        theme.palette.text.secondary,
        theme.palette.primary.main,
        theme.palette.success.main,
        isDefaultListMdDown,
        isDefaultListSmDown,
        formatProtocol,
        getInitials,
        buildListActionsColumn,
    ]);


    // Aqui existia um `useEffect` que buscava `/filters` e DESCARTAVA o
    // resultado, dependendo de `props.filters` -- ou seja, do proprio dado que
    // a chamada de verdade (`fetchFilters`, logo abaixo) atualiza. Cada
    // atualizacao disparava outra busca inutil: seis requisicoes por abertura,
    // medidas em producao. Quem alimenta os filtros e o `fetchFilters`.

         useEffect(() => {
         props.fetchTickets();
         props.fetchFilters();
         // eslint-disable-next-line react-hooks/exhaustive-deps
     }, []);

    return (
        <Grid className={styles.container} sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '1rem 1.5rem',
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                gap: 1.5
            }}>
                <Box sx={{ flex: '0 0 auto' }}>
                    <Typography variant="h5" fontWeight={700} sx={{ color: theme.palette.text.primary, lineHeight: 1.2 }}>
                        {props.selectedFilter?.name || 'Tickets'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mt: 0.5 }}>
                        {(() => {
                            const loaded = rows.length;
                            const fmt = (n) => n.toLocaleString('pt-BR');
                            const unit = (n) => (n === 1 ? 'ticket' : 'tickets');

                            // Kanban: usa o total agregado do servidor (os tickets ficam
                            // nas colunas, não em `rows` — por isso não dá pra usar loaded).
                            if (viewMode === 'kanban') {
                                const kt = typeof kanbanCounts?.total === 'number' ? kanbanCounts.total : loaded;
                                if (kt === 0) {
                                    return estadoDaListagem({ carregando, quantidade: 0 }) === CARREGANDO
                                        ? TEXTO_CARREGANDO
                                        : 'Nenhum ticket encontrado';
                                }
                                return `${fmt(kt)} ${unit(kt)}`;
                            }

                            // Lista: total real da visão (server-side / painel por ids);
                            // se não for representável, usa o nº carregado com "+".
                            let total = loaded;
                            let exact = false;
                            if (panelFilter && Array.isArray(panelFilter.ids)) {
                                total = panelFilter.ids.length; exact = true;
                            } else if (listTotal != null) {
                                total = listTotal; exact = true;
                            }
                            if (total === 0) {
                                return estadoDaListagem({ carregando, quantidade: 0 }) === CARREGANDO
                                    ? TEXTO_CARREGANDO
                                    : 'Nenhum ticket encontrado';
                            }
                            const more = !exact && (serverSearchResults != null
                                ? (searchMeta.page > 0 && searchMeta.page < searchMeta.lastPage)
                                : finalizedHasMore);
                            const totalStr = fmt(total) + (more ? '+' : '');
                            const from = Math.min(visibleRange.startIndex + 1, loaded);
                            const to = Math.min(visibleRange.endIndex + 1, loaded);
                            return `Exibindo ${fmt(from)} a ${fmt(to)} de ${totalStr} ${unit(total)}`;
                        })()}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: { xs: 'center', md: 'flex-end' },
                        gap: 0.75,
                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                        justifyContent: 'flex-end',
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flexWrap: 'nowrap', flexShrink: 0 }}>
                        {panelFilter && (
                            <Chip
                                label={`Painel: ${panelFilter.label}`}
                                color="primary"
                                variant="outlined"
                                size="small"
                                onDelete={() => setPanelFilter(null)}
                                sx={{ mr: 0 }}
                            />
                        )}
                        {props.selectedFilter && (
                            <Chip
                                label={`Filtro: ${props.selectedFilter.name}`}
                                color='success'
                                variant="outlined"
                                size="small"
                                onDelete={handleClearFilter}
                                sx={{ mr: 0 }}
                            />
                        )}
                        {indicatorShortcut && (
                            <Chip
                                /*
                                  O sufixo só aparece se o teto de páginas de
                                  "abertos hoje" tiver cortado a lista. Sem
                                  ele, um dia anormal voltaria a mostrar menos
                                  linhas do que o card prometeu -- calado, que
                                  é exatamente o defeito que o item 1 conserta.
                                */
                                label={
                                    linhasDeHoje != null && totalDeHoje != null && linhasDeHoje.length < totalDeHoje
                                        ? `Indicadores: ${indicatorShortcutLabel} (mostrando ${linhasDeHoje.length} de ${totalDeHoje})`
                                        : `Indicadores: ${indicatorShortcutLabel}`
                                }
                                color="secondary"
                                variant="outlined"
                                size="small"
                                onDelete={() => setIndicatorShortcut(null)}
                                sx={{ mr: 0 }}
                            />
                        )}
                        {advancedSearchFilters && (
                            <Chip
                                label="Busca avançada ativa"
                                color='primary'
                                variant="outlined"
                                size="small"
                                onDelete={() => setAdvancedSearchFilters(null)}
                                sx={{ mr: 0 }}
                            />
                        )}
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={handleOpenOptionsMenu}
                            sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 1,
                                minWidth: 'auto'
                            }}
                        >
                            Opções
                        </Button>
                    </Box>
                    <Box sx={{ flex: '1 1 420px', minWidth: { xs: '100%', md: 360 }, maxWidth: { xs: '100%', md: 620 } }}>
                        <SearchBar
                            options={props.tickets.tickets.map(ticket => mapTicketToSearchString(ticket))}
                            onSearchChange={(value) => setSearchValue(value)}
                            initialValue={searchValue}
                            sortOrder="asc"
                            placeholder="Pesquisar por protocolo, assunto ou cliente..."
                            clearSearch={() => {
                                setSearchValue('');
                                setAdvancedSearchFilters(null);
                                setIndicatorShortcut(null);
                                limparRefinamentosDaListagem();
                            }}
                            onAdvancedSearch={() => setAdvancedSearchOpen(true)}
                            sx={{
                                width: '100%',
                                minWidth: 0,
                                '& .MuiFilledInput-root': {
                                    borderRadius: 2,
                                    minHeight: 40,
                                    backgroundColor: 'transparent',
                                    '&:hover': { backgroundColor: 'transparent' },
                                    '&.Mui-focused': { backgroundColor: 'transparent' },
                                },
                                '& .MuiFilledInput-input': {
                                    paddingTop: '10px',
                                    paddingBottom: '10px',
                                    color: theme.palette.text.primary,
                                    caretColor: theme.palette.text.primary,
                                },
                                '& .MuiFilledInput-input::placeholder': {
                                    color: theme.palette.text.secondary,
                                    opacity: 0.85,
                                },
                                '& .MuiIconButton-root': {
                                    padding: 0.5,
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: '1.05rem',
                                },
                            }}
                        />
                    </Box>
                </Box>
            </Box>

            <Box sx={{ px: '1.5rem', minWidth: 0, flex: 1, display: 'flex', overflow: 'hidden', gap: 2 }}>
                <Box
                    sx={{
                        width: { xs: '100%', md: shouldCollapseFilterPanel ? 52 : 232 },
                        flexShrink: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 2,
                        backgroundColor: theme.palette.background.paper,
                        overflow: 'hidden',
                        alignSelf: 'flex-start',
                        position: { xs: 'relative', md: 'sticky' },
                        top: { md: 0 },
                        maxHeight: { xs: 'none', md: 'calc(100vh - 140px)' },
                    }}
                >
                    <Box sx={{ p: 1.25, borderBottom: `1px solid ${theme.palette.divider}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                            {props.selectedFilter ? <FilterAltSharp fontSize="small" /> : <FilterListIcon fontSize="small" />}
                            {!shouldCollapseFilterPanel && (
                                <Typography variant="subtitle1" fontWeight={700} noWrap sx={{ color: theme.palette.text.primary }}>
                                    Filtros
                                </Typography>
                            )}
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                            {!shouldCollapseFilterPanel && (props.selectedFilter || indicatorShortcut) && (
                                <Button size="small" variant="text" onClick={handleClearFilter} sx={{ textTransform: 'none' }}>
                                    Limpar
                                </Button>
                            )}
                            {!isTicketMobileLayout && (
                                <Tooltip title={shouldCollapseFilterPanel ? 'Expandir filtros' : 'Minimizar filtros'}>
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setIsFilterPanelCollapsed((prev) => {
                                                const next = !prev;
                                                try {
                                                    localStorage.setItem('ticket-page-filter-panel-collapsed', String(next));
                                                } catch { /* ignore */ }
                                                return next;
                                            });
                                        }}
                                        aria-label={shouldCollapseFilterPanel ? 'Expandir filtros' : 'Minimizar filtros'}
                                    >
                                        {shouldCollapseFilterPanel ? <ChevronRight fontSize="small" /> : <ChevronLeft fontSize="small" />}
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    </Box>

                    {!shouldCollapseFilterPanel && (
                        <>
                            <Box sx={{ p: 1, overflow: 'auto', minHeight: 0 }}>
                                {/*
                                  * A lista saiu daqui para `components/ListaDeFiltros`
                                  * quando ganhou reordenacao por arraste (ponto 22 da
                                  * Gisele): estado, persistencia e arraste dentro de
                                  * uma IIFE num arquivo de seis mil linhas nao tem como
                                  * ser conferido. A separacao compartilhado/pessoal e a
                                  * mesma, e continua em `utils/compartilhamentoDoFiltro`.
                                  */}
                                <ListaDeFiltros
                                    filtros={props.filters}
                                    filtroSelecionado={props.selectedFilter}
                                    operadorId={props.currentUser?.id}
                                    onSelecionar={handleFilterApplied}
                                />
                            </Box>

                            <Divider />
                            <Box sx={{ p: 1 }}>
                                <Button
                                    component={Link}
                                    to="/filtros"
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<SettingsFilterIcon fontSize="small" />}
                                    sx={{ borderRadius: 2, textTransform: 'none', justifyContent: 'flex-start' }}
                                >
                                    Gerenciar filtros
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>

                <Box sx={{ minWidth: 0, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    {/*
                      * O scroll horizontal do kanban mora AQUI, e é um só.
                      *
                      * Antes cada grid rolava por conta própria -- a faixa de
                      * cabeçalhos, e um grid por responsável. Rolar o grupo de
                      * um responsável não movia nem o cabeçalho nem os outros
                      * grupos, então as colunas saíam de alinhamento assim que
                      * alguém rolava.
                      *
                      * Com o scroll no wrapper, o cabeçalho continua grudado
                      * no topo (o `sticky` é no eixo vertical) e anda junto na
                      * horizontal, que é o que o alinha.
                      *
                      * Só no kanban: na listagem o conteúdo é `width: 100%` e
                      * nunca transborda, mas deixar `hidden` ali mantém o
                      * comportamento de hoje sem depender disso.
                      */}
                    {/*
                      * A barra de carregamento.
                      *
                      * `height: 3` e posição reservada sempre (a barra existe
                      * no fluxo mesmo parada, invisível): sem isso a tela
                      * pularia 3px a cada carregamento, e o kanban, que já
                      * rola nos dois eixos, perderia a posição de leitura.
                      *
                      * Fora do wrapper rolável de propósito: dentro dele, a
                      * barra sairia da vista assim que alguém rolasse para
                      * baixo -- justamente enquanto espera.
                      */}
                    <Box sx={{ height: 3, flex: '0 0 auto' }}>
                        {carregando && (
                            <LinearProgress
                                data-testid="carregando-chamados"
                                aria-label={TEXTO_CARREGANDO}
                                sx={{ height: 3 }}
                            />
                        )}
                    </Box>
                    <Box ref={tableWrapperRef} className={styles.ticketTableWrapper} sx={{ flex: 1, overflowY: 'auto', overflowX: viewMode === 'kanban' ? 'auto' : 'hidden', minHeight: 0 }}>
                        {viewMode !== 'kanban' && rows.length === 0 && props.selectedFilter && props.selectedFilter.conditions && props.selectedFilter.conditions.length > 0 ? (
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                gap: 2,
                                p: 4
                            }}>
                                {/*
                                  * Enquanto carrega, esta área dizia "Não há
                                  * tickets que satisfaçam as condições do
                                  * filtro" -- a MESMA frase do resultado
                                  * vazio de verdade. Quem abria um filtro
                                  * grande lia que não havia nada enquanto o
                                  * servidor ainda respondia.
                                  */}
                                <FilterListIcon sx={{ fontSize: 64, color: theme.palette.text.secondary }} />
                                <Typography variant="h6" color="text.secondary">
                                    {estadoDaListagem({ carregando, quantidade: rows.length }) === CARREGANDO
                                        ? TEXTO_CARREGANDO
                                        : 'Nenhum ticket encontrado'}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', maxWidth: 400 }}>
                                    {estadoDaListagem({ carregando, quantidade: rows.length }) === CARREGANDO
                                        ? 'Buscando os chamados deste filtro no servidor.'
                                        : 'Não há tickets que satisfaçam as condições do filtro aplicado. Tente ajustar os critérios de busca.'}
                                </Typography>
                            </Box>
                        ) : viewMode === 'kanban' && kanbanColumnsFromFilter.length > 0 ? (
                            <>
                                {/*
                                  Ordenação dos cartões dentro das colunas (K9).
                                  Fica FORA da área grudada no topo de propósito:
                                  ali o espaço é dos títulos das colunas, que são
                                  o que a pessoa precisa ver ao rolar.
                                */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                        Ordenar por
                                    </Typography>
                                    <TextField
                                        select
                                        size="small"
                                        value={kanbanSort.campo}
                                        onChange={(e) => setKanbanSort((prev) => ({ ...prev, campo: e.target.value }))}
                                        inputProps={{ 'aria-label': 'Ordenar os cartões do quadro por' }}
                                        sx={{ minWidth: 190 }}
                                    >
                                        {OPCOES_DE_ORDENACAO.map((opcao) => (
                                            <MenuItem key={opcao.campo} value={opcao.campo}>
                                                {opcao.rotulo}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <Tooltip
                                        title={kanbanSort.direcao === 'desc' ? 'Do maior para o menor' : 'Do menor para o maior'}
                                        arrow
                                    >
                                        <IconButton
                                            size="small"
                                            aria-label={kanbanSort.direcao === 'desc'
                                                ? 'Ordem decrescente; clique para crescente'
                                                : 'Ordem crescente; clique para decrescente'}
                                            onClick={() => setKanbanSort((prev) => ({
                                                ...prev,
                                                direcao: prev.direcao === 'desc' ? 'asc' : 'desc',
                                            }))}
                                            sx={{ color: theme.palette.text.secondary }}
                                        >
                                            {kanbanSort.direcao === 'desc'
                                                ? <ArrowDownward fontSize="small" />
                                                : <ArrowUpward fontSize="small" />}
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 2,
                                        pb: 1,
                                        backgroundColor: theme.palette.background.default,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'grid',
                                            /*
                                             * A MESMA medida do corpo, de
                                             * `utils/cabeNaColuna`.
                                             *
                                             * Aqui era `minmax(0, 1fr)` com
                                             * `gap: 2`, enquanto o corpo usava
                                             * `minmax(260px, 1fr)` com
                                             * `gap: 1`. Medido na tela em
                                             * 14/10/2026, com 5 colunas em
                                             * 900px: o cabeçalho espremia a
                                             * 167px por coluna e não
                                             * transbordava; o corpo ficava em
                                             * 260px e transbordava. O rótulo
                                             * não ficava em cima da coluna que
                                             * nomeava, e rolar os cartões não
                                             * movia o cabeçalho.
                                             */
                                            gridTemplateColumns: gradeDeColunas(kanbanColumnsFromFilter && kanbanColumnsFromFilter.length),
                                            gap: `${ESPACO_ENTRE_COLUNAS}px`,
                                            minWidth: `${larguraMinimaDaGrade(kanbanColumnsFromFilter && kanbanColumnsFromFilter.length)}px`,
                                        }}
                                    >
                                        {kanbanColumnsFromFilter.map((col) => {
                                            const count = Array.isArray(ticketsByColumn?.[col.id]) ? ticketsByColumn[col.id].length : 0;
                                            const total = serverSearchResults == null ? columnTotal(col) : null;
                                            return (
                                                <Box
                                                    key={col.id}
                                                    sx={{
                                                        borderRadius: 2,
                                                        border: `1px solid ${theme.palette.divider}`,
                                                        backgroundColor: theme.palette.background.paper,
                                                        px: 1.5,
                                                        py: 1,
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 1 }}>
                                                        <Typography variant="subtitle2" fontWeight={800} sx={{ color: theme.palette.text.primary, lineHeight: 1.2 }}>
                                                            {col.name}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: `${theme.palette.text.secondary} !important`, fontWeight: 700 }}>
                                                            {total != null ? `${count}/${total}` : count}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                </Box>
                                {/*
                                  Os resultados que o quadro não tem onde
                                  desenhar. Ficam aqui, clicáveis, em vez de
                                  sumirem: o chamado procurado costuma ser
                                  justamente o que está num status que este
                                  Kanban não cobre.
                                */}
                                {resultadosForaDasColunas.length > 0 && (
                                    <Box
                                        data-testid="resultados-fora-das-colunas"
                                        sx={{
                                            mb: 1.5,
                                            px: 1.5,
                                            py: 1,
                                            borderRadius: 1,
                                            border: `1px solid ${theme.palette.divider}`,
                                            backgroundColor: theme.palette.action.hover,
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ color: `${theme.palette.text.secondary} !important`, fontWeight: 600 }}>
                                            {resultadosForaDasColunas.length === 1
                                                ? '1 resultado fora das colunas deste Kanban'
                                                : `${resultadosForaDasColunas.length} resultados fora das colunas deste Kanban`}
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 0.75 }}>
                                            {resultadosForaDasColunas.slice(0, 8).map((t) => (
                                                <Chip
                                                    key={t.id}
                                                    size="small"
                                                    variant="outlined"
                                                    clickable
                                                    onClick={() => handleRowClick(t)}
                                                    label={`${formatProtocol(t.number)} — ${t.title || 'Sem título'}`}
                                                />
                                            ))}
                                            {resultadosForaDasColunas.length > 8 && (
                                                <Typography variant="caption" sx={{ color: `${theme.palette.text.secondary} !important`, alignSelf: 'center' }}>
                                                    e mais {resultadosForaDasColunas.length - 8}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                )}
                                <TicketKanbanView
                                    columns={kanbanColumnsFromFilter}
                                    ticketsByColumn={ticketsByColumn}
                                    onCardClick={handleRowClick}
                                    onStatusChange={true}
                                    onExpandedAssigneesChange={handleExpandedAssigneesChange}
                                    editTicket={props.editTicket}
                                    visibleCardFields={kanbanCardFields}
                                    showGlobalColumnHeaders={false}
                                    assigneeCounts={visibleAssigneeCounts}
                                    onLoadColumnMore={handleLoadColumnMore}
                                    groupExtra={groupExtra}
                                    responsavelVisivel={responsavelVisivelNoKanbanAtual}
                                />
                            </>
                        ) : (
                            <TicketListVirtuoso
                                rows={rows}
                                columns={props.selectedFilter ? [...dynamicColumns] : [...defaultListColumns]}
                                selectedIds={selectedTicketIds}
                                onSelectionChange={setSelectedTicketIds}
                                onRowClick={(ticket) => handleRowClick(ticket)}
                                onEndReached={handleListEndReached}
                                onRangeChange={setVisibleRange}
                                sort={sort}
                                onSortChange={handleSortChange}
                                sortDisabledReason={sortDisabledReason}
                            />
                        )}
                    </Box>
                </Box>
            </Box>

            <LixeiraDeChamados
                open={lixeiraAberta}
                onClose={() => setLixeiraAberta(false)}
                /*
                 * Recarrega a lista depois de restaurar: o chamado voltou, e
                 * deixar a tela como estava faria parecer que nada aconteceu.
                 */
                onRestaurado={() => props.fetchTickets && props.fetchTickets()}
            />

            <AdvancedSearchModal
                open={advancedSearchOpen}
                onClose={() => setAdvancedSearchOpen(false)}
                onApply={(filters) => {
                    setAdvancedSearchFilters(filters);
                }}
                onClear={() => {
                    setAdvancedSearchFilters(null);
                }}
            />

            <Menu
                anchorEl={actionsAnchorEl}
                open={Boolean(actionsAnchorEl)}
                onClose={handleCloseActionsMenu}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem
                    onClick={handleOpenTransferModal}
                    disabled={!canTransferTicket(actionsTicket)}
                >
                    <ListItemIcon>
                        <SwapHoriz fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Transferir ticket"
                        secondary={actionsTicket && isResolvedOrCancelled(actionsTicket) ? 'Não disponível para tickets resolvidos ou cancelados' : null}
                    />
                </MenuItem>
                <MenuItem
                    onClick={handleOpenMergeModal}
                    disabled={!canMergeTickets || !actionsTicket}
                >
                    <ListItemIcon>
                        <MergeType fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Mesclar / relacionar tickets"
                        secondary={!canMergeTickets ? 'Sem permissão para mesclar tickets' : null}
                    />
                </MenuItem>
            </Menu>

            <Menu
                anchorEl={optionsAnchorEl}
                open={Boolean(optionsAnchorEl)}
                onClose={handleCloseOptionsMenu}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionProps={{ timeout: 0 }}
                PaperProps={{ sx: { minWidth: 220 } }}
            >
                <MenuItem onClick={handleExportCSV}>
                    <ListItemIcon>
                        <FileDownload fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Exportar como CSV" secondary={selectedTicketIds.length > 0 ? `${selectedTicketIds.length} selecionado(s)` : 'Todos os tickets'} />
                </MenuItem>
                <MenuItem onClick={handleExportXLSX}>
                    <ListItemIcon>
                        <FileDownload fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Exportar como XLSX" secondary={selectedTicketIds.length > 0 ? `${selectedTicketIds.length} selecionado(s)` : 'Todos os tickets'} />
                </MenuItem>
                <MenuItem onClick={handleExportJSON}>
                    <ListItemIcon>
                        <FileDownload fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Exportar como JSON" secondary={selectedTicketIds.length > 0 ? `${selectedTicketIds.length} selecionado(s)` : 'Todos os tickets'} />
                </MenuItem>
                {/*
                  * A lixeira (pontos 8 e 9 da Gisele), DEPOIS das três
                  * exportações e separada delas: entre "Exportar como XLSX" e
                  * "Exportar como JSON" ela parecia ter caído ali por
                  * acidente -- foi como ficou no primeiro deploy, e dá para
                  * ver na tela.
                  *
                  * Só para quem pode excluir: quem pode destruir tem de poder
                  * desfazer. O servidor valida o mesmo; este `if` é só a tela.
                  */}
                {/*
                  * LISTA, e não `<>...</>`: o `Menu` do MUI percorre os
                  * filhos um por um para dar foco e navegação por teclado, e
                  * ele não entra dentro de um Fragment -- avisava isso no
                  * console (19 vezes a cada abertura da tela) e, de verdade,
                  * as setas do teclado pulavam estes itens.
                  */}
                {canDeleteTickets && [
                    <Divider key="divisor-da-lixeira" sx={{ my: 1 }} />,
                    <MenuItem key="lixeira" onClick={() => { handleCloseOptionsMenu(); setLixeiraAberta(true); }}>
                        <ListItemIcon>
                            <DeleteOutline fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Lixeira de chamados" secondary="Consultar e restaurar excluídos" />
                    </MenuItem>,
                ]}
                {selectedTicketIds.length > 0 && (() => {
                    const selectedTickets = rows.filter(r => selectedTicketIds.includes(r.id));
                    const hasResolvedOrCancelled = selectedTickets.some(t => isResolvedOrCancelled(t));
                    return [
                            <Divider key="divisor-dos-selecionados" sx={{ my: 1 }} />,
                            <MenuItem
                                key="transferir-selecionados"
                                onClick={handleOpenBulkTransferModal}
                                disabled={hasResolvedOrCancelled}
                            >
                                <ListItemIcon>
                                    <SwapHoriz fontSize="small" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`Transferir selecionados (${selectedTicketIds.length})`}
                                    secondary={hasResolvedOrCancelled ? 'Remova tickets resolvidos ou cancelados da seleção' : null}
                                />
                            </MenuItem>,
                            <MenuItem
                                key="alterar-status-dos-selecionados"
                                onClick={() => { handleCloseOptionsMenu(); setBulkStatusValue({ statusId: null, substatusId: null }); setBulkStatusOpen(true); }}
                            >
                                <ListItemIcon>
                                    <LabelOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={`Alterar status (${selectedTicketIds.length})`} />
                            </MenuItem>,
                            <MenuItem
                                key="alterar-servico-dos-selecionados"
                                onClick={() => { handleCloseOptionsMenu(); setBulkServiceId(null); setBulkServiceOpen(true); }}
                            >
                                <ListItemIcon>
                                    <MiscellaneousServices fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={`Alterar serviço (${selectedTicketIds.length})`} />
                            </MenuItem>,
                            canDeleteTickets && (
                                <MenuItem
                                    key="excluir-selecionados"
                                    onClick={() => { handleCloseOptionsMenu(); setBulkDeleteOpen(true); }}
                                    sx={{ color: theme.palette.error.main }}
                                >
                                    <ListItemIcon>
                                        <DeleteOutline fontSize="small" sx={{ color: theme.palette.error.main }} />
                                    </ListItemIcon>
                                    <ListItemText primary={`Excluir selecionados (${selectedTicketIds.length})`} />
                                </MenuItem>
                            ),
                    ];
                })()}
            </Menu>

            <Dialog open={bulkDeleteOpen} onClose={() => !bulkDeleting && setBulkDeleteOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ color: theme.palette.error.main }}>Excluir tickets</DialogTitle>
                <DialogContent>
                    {/*
                      * Dizia "esta ação é permanente e não pode ser desfeita",
                      * e desde a lixeira (pontos 8 e 9 da Gisele) isso ficou
                      * FALSO. Aviso que mente nos dois sentidos: assusta quem
                      * tinha razão em excluir, e não ensina onde recuperar
                      * quem excluiu por engano -- que é o caso que a lixeira
                      * existe para atender.
                      */}
                    <Typography variant="body2">
                        Tem certeza que deseja excluir <strong>{selectedTicketIds.length}</strong> ticket(s) selecionado(s)?
                        Eles saem da listagem e vão para a lixeira, de onde podem ser restaurados
                        em Opções &rsaquo; Lixeira de chamados.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setBulkDeleteOpen(false)} color="inherit" disabled={bulkDeleting}>Cancelar</Button>
                    <Button onClick={handleBulkDelete} color="error" variant="contained" disabled={bulkDeleting}>
                        {bulkDeleting ? 'Excluindo...' : 'Excluir'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Ação rápida: alterar status dos selecionados */}
            <Dialog open={bulkStatusOpen} onClose={() => !bulkApplying && setBulkStatusOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Alterar status ({selectedTicketIds.length})</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                        O status escolhido será aplicado aos {selectedTicketIds.length} ticket(s) selecionado(s).
                    </Typography>
                    <StatusJustificationPicker
                        statuses={ticketStatuses}
                        statusId={bulkStatusValue.statusId}
                        substatusId={bulkStatusValue.substatusId}
                        onSelect={({ statusId, substatusId }) => setBulkStatusValue({ statusId, substatusId })}
                        placeholder="Selecione o status ou a justificativa"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setBulkStatusOpen(false)} color="inherit" disabled={bulkApplying}>Cancelar</Button>
                    <Button onClick={handleBulkApplyStatus} variant="contained" disabled={bulkApplying || bulkStatusValue.statusId == null}>
                        {bulkApplying ? 'Aplicando...' : 'Aplicar'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Ação rápida: alterar serviço dos selecionados */}
            <Dialog open={bulkServiceOpen} onClose={() => !bulkApplying && setBulkServiceOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Alterar serviço ({selectedTicketIds.length})</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                        O serviço escolhido será aplicado aos {selectedTicketIds.length} ticket(s) selecionado(s).
                    </Typography>
                    <ServicePicker
                        services={services}
                        value={bulkServiceId}
                        onChange={(nextId) => setBulkServiceId(nextId)}
                        requireLeaf
                        placeholder="Selecione um serviço"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setBulkServiceOpen(false)} color="inherit" disabled={bulkApplying}>Cancelar</Button>
                    <Button onClick={handleBulkApplyService} variant="contained" disabled={bulkApplying || bulkServiceId == null}>
                        {bulkApplying ? 'Aplicando...' : 'Aplicar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={transferModalOpen}
                onClose={handleCloseTransferModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Transferir ticket</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                        Selecione o novo responsável para este ticket.
                    </Typography>
                    <Autocomplete
                        sx={{ mt: 1 }}
                        noOptionsText="Nenhuma opção"
                        options={(props.users || []).sort((a, b) => {
                            const groupA = a.service_group?.description || 'Sem departamento';
                            const groupB = b.service_group?.description || 'Sem departamento';
                            if (groupA !== groupB) return groupA.localeCompare(groupB);
                            return (a.name || '').localeCompare(b.name || '');
                        })}
                        groupBy={(option) => option.service_group?.description || 'Sem departamento'}
                        getOptionLabel={(option) => {
                            if (typeof option === 'string') return option;
                            return option.name || option.email || '';
                        }}
                        filterOptions={(options, state) => {
                            const inputValue = state.inputValue.toLowerCase().trim();
                            if (!inputValue) return options;
                            return options.filter(option => {
                                const name = (option.name || '').toLowerCase();
                                const email = (option.email || '').toLowerCase();
                                return name.includes(inputValue) || email.includes(inputValue);
                            });
                        }}
                        value={transferUser}
                        onChange={(event, newValue) => {
                            setTransferUser(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Responsável"
                                placeholder="Buscar por nome ou email..."
                                size="small"
                            />
                        )}
                        renderGroup={(params) => (
                            <li key={params.key}>
                                <ListSubheader
                                    sx={{
                                        backgroundColor: theme.palette.mode === 'dark'
                                            ? theme.palette.grey[800]
                                            : theme.palette.grey[100],
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        color: theme.palette.text.primary,
                                        py: 0.5,
                                        lineHeight: 1.4
                                    }}
                                >
                                    {params.group}
                                </ListSubheader>
                                {params.children}
                            </li>
                        )}
                        renderOption={(propsOption, option) => (
                            <Box component="li" {...propsOption} key={option.id}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2 }}>
                                    <Typography variant="body2">{option.name || 'Sem nome'}</Typography>
                                    {option.email && (
                                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                            {option.email}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseTransferModal}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleConfirmTransfer}
                        variant="contained"
                        color="primary"
                        disabled={!transferUser}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={mergeModalOpen}
                onClose={handleCloseMergeModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Mesclar tickets</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                        Escolha o ticket que será mesclado com o ticket atual e defina qual deve permanecer como principal.
                    </Typography>
                    <Autocomplete
                        noOptionsText="Nenhuma opção"
                        options={(props.tickets.tickets || []).filter((t) =>
                            actionsTicket && Number(t.id) !== Number(actionsTicket.id) && !t.merged_into_ticket_id
                        )}
                        getOptionLabel={(option) => `#${option.number} - ${option.title || 'Sem título'}`}
                        value={mergeTargetTicket}
                        onChange={(event, newValue) => setMergeTargetTicket(newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Ticket para mesclar"
                                size="small"
                            />
                        )}
                        isOptionEqualToValue={(option, value) => Number(option.id) === Number(value?.id)}
                    />
                    <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
                        Ticket principal após a mesclagem
                    </Typography>
                    <RadioGroup
                        value={mergePrimaryChoice}
                        onChange={(e) => setMergePrimaryChoice(e.target.value)}
                    >
                        <FormControlLabel
                            value="current"
                            control={<Radio size="small" />}
                            label={`Manter atual como principal${actionsTicket ? ` (#${actionsTicket.number})` : ''}`}
                        />
                        <FormControlLabel
                            value="target"
                            control={<Radio size="small" />}
                            label={`Manter selecionado como principal${mergeTargetTicket ? ` (#${mergeTargetTicket.number})` : ''}`}
                            disabled={!mergeTargetTicket}
                        />
                    </RadioGroup>
                    <FormControlLabel
                        sx={{ mt: 0.5 }}
                        control={
                            <Checkbox
                                size="small"
                                checked={rememberMergeChoice}
                                onChange={(e) => setRememberMergeChoice(e.target.checked)}
                            />
                        }
                        label="Usar esta opção como padrão nas próximas mesclagens"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseMergeModal}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleConfirmMerge}
                        variant="contained"
                        color="primary"
                        disabled={!mergeTargetTicket || mergeSaving}
                    >
                        {mergeSaving ? 'Mesclando...' : 'Confirmar mesclagem'}
                    </Button>
                </DialogActions>
            </Dialog>

        </Grid>
    );
}

const mapStateToProps = state => {
    const { tickets, loading, error, field, filter, user } = state;
    const { fields } = field;
    const { filters, selectedFilter } = filter;
    const { users, currentUser, permissions } = user;

    return {
        tickets,
        loading,
        error,
        fields,
        filters,
        selectedFilter,
        users,
        currentUser,
        permissions: permissions || [],
    };
};

const mapDispatchToProps = dispatch => ({
    fetchTickets: () => dispatch(fetchTickets()),
    createTicket: ticket => dispatch(createTicket(ticket)),
    addFilter: filter => dispatch(addFilter(filter)),
    updateFilter: filter => dispatch(updateFilter(filter)),
    fetchFilters: () => dispatch(fetchFilters()),
    setViewedTickets: tickets => dispatch(setViewedTickets(tickets)),
    setSelectedFilter: filter => dispatch(setSelectedFilter(filter)),
    mapPriority: priority => dispatch(mapPriority(priority)),
    mapStatus: status => dispatch(mapStatus(status)),
    editTicket: ticket => dispatch(editTicket(ticket)),
    getUsers: () => dispatch(getUsers()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketPage));